import { TranslationObject } from "../types";

const DEUTSCH_TRANSLATIONS: TranslationObject = {
  CLASSES: {
    id: "CLASSES",
    defaultMessage: "Startseite",
  },
  PARTICIPATION: {
    id: "PARTICIPATION",
    defaultMessage: "Mitarbeit",
  },
  ATTENDANCE: {
    id: "ATTENDANCE",
    defaultMessage: "Anwesenheit",
  },
  PRESENT: {
    id: "PRESENT",
    defaultMessage: "anwesend",
  },
  ABSENT: {
    id: "ABSENT",
    defaultMessage: "abwesend",
  },
  SOON: {
    id: "SOON",
    defaultMessage: "Demnächst",
  },
  CLASS_ROOMS: {
    id: "CLASS_ROOMS",
    defaultMessage: "Kurse",
  },
  CLASS_ROOM: {
    id: "CLASS_ROOM",
    defaultMessage: "Kurs",
  },
  LANGUAGES: {
    id: "LANGUAGES",
    defaultMessage: "Sprachen",
  },
  ACCOUNT_SETTINGS: {
    id: "ACCOUNT_SETTINGS",
    defaultMessage: "Account Einstellungen",
  },
  LOGOUT: {
    id: "LOGOUT",
    defaultMessage: "Abmelden",
  },
  LOGOUT_CONFIRM_TITLE: {
    id: "LOGOUT_CONFIRM_TITLE",
    defaultMessage: "Abmelden?",
  },
  LOGOUT_CONFIRM_BODY: {
    id: "LOGOUT_CONFIRM_BODY",
    defaultMessage: "Du musst dich erneut anmelden, um auf deine Klassen zuzugreifen.",
  },
  ADD: {
    id: "ADD",
    defaultMessage: "hinzufügen",
  },
  EDIT: {
    id: "EDIT",
    defaultMessage: "Bearbeiten",
  },
  REMOVE: {
    id: "REMOVE",
    defaultMessage: "Löschen",
  },
  OBSERVATION: {
    id: "OBSERVATION",
    defaultMessage: "Beobachtung",
  },
  NO_DATA: {
    id: "NO_DATA",
    defaultMessage: "keine Daten",
  },
  STUDENTS: {
    id: "STUDENTS",
    defaultMessage: "Schüler*innen",
  },
  SUBJECT: {
    id: "SUBJECT",
    defaultMessage: "Unterrichtsfach",
  },
  CREATED_AT: {
    id: "CREATED_AT",
    defaultMessage: "Erstellt am",
  },
  STUDENT: {
    id: "STUDENT",
    defaultMessage: "Schüler*in",
  },
  DATE: {
    id: "DATE",
    defaultMessage: "Datum",
  },
  HOME_WORK: {
    id: "HOME_WORK",
    defaultMessage: "Hausaufgabe",
  },
  RESET: {
    id: "RESET",
    defaultMessage: "zurücksetzen",
  },
  REMOVE_QUALIFICATION: {
    id: "REMOVE_QUALIFICATION",
    defaultMessage: "Bewertung löschen",
  },
  REMOVE_STUDENT: {
    id: "REMOVE_STUDENT",
    defaultMessage: "Schüler*in löschen",
  },
  QUALIFIED: {
    id: "QUALIFIED",
    defaultMessage: "Bewertet",
  },
  NOT_QUALIFIED: {
    id: "NOT_QUALIFIED",
    defaultMessage: "Ohne Bewertung",
  },
  OPTIONS: {
    id: "OPTIONS",
    defaultMessage: "Optionen",
  },
  LESSON_DATE: {
    id: "LESSON_DATE",
    defaultMessage: "Datum",
  },
  DATE_RANGE: {
    id: "DATE_RANGE",
    defaultMessage: "Zeitraum",
  },
  LAST_WEEK: {
    id: "LAST_WEEK",
    defaultMessage: "In der letzten Woche",
  },
  LAST_MONTH: {
    id: "LAST_MONTH",
    defaultMessage: "Im letzten Monat",
  },
  LAST_3_MONTHS: {
    id: "LAST_3_MONTHS",
    defaultMessage: "In den letzten 3 Monaten",
  },
  LAST_6_MONTHS: {
    id: "LAST_6_MONTHS",
    defaultMessage: "In den letzten 6 Monaten",
  },
  LAST_YEAR: {
    id: "LAST_YEAR",
    defaultMessage: "Im letzten Jahr",
  },
  CUSTOM_DATE: {
    id: "CUSTOM_DATE",
    defaultMessage: "Eigener Zeitraum",
  },
  NO_PARTICIPATION: {
    id: "NO_PARTICIPATION",
    defaultMessage: "Keine Mitarbeit",
  },
  USELESS: {
    id: "USELESS",
    defaultMessage: "Kaum Mittarbeit",
  },
  POOR: {
    id: "POOR",
    defaultMessage: "Vereinzelte Mitarbeit",
  },
  OK: {
    id: "OK",
    defaultMessage: "Konstante Mitarbeit",
  },
  GOOD: {
    id: "GOOD",
    defaultMessage: "Engagierte Mitarbeit",
  },
  EXCELENT: {
    id: "EXCELENT",
    defaultMessage: "Exzellente Mitarbeit",
  },
  TOTAL_AVERAGE: {
    id: "TOTAL_AVERAGE",
    defaultMessage: "Gesamtbewertung",
  },
  INDIVIDUAL_EVALUATIONS: {
    id: "INDIVIDUAL_EVALUATIONS",
    defaultMessage: "Einzelne Bewertungen im Überblick ",
  },
  MONTLY_REVIEW: {
    id: "MONTLY_REVIEW",
    defaultMessage: "Bewertung in diesem Monat",
  },
  EVALUATION: {
    id: "EVALUATION",
    defaultMessage: "Bewertung",
  },
  STARS: {
    id: "STARTS",
    defaultMessage: "Sterne",
  },
  STAR: {
    id: "STAR",
    defaultMessage: "ein Stern",
  },
  NO_STARTS: {
    id: "NO_STARTS",
    defaultMessage: "kein Stern",
  },
  JANUAR: {
    id: "JANUAR",
    defaultMessage: "Januar",
  },
  FEBRUARY: {
    id: "FEBRUARY",
    defaultMessage: "Februar",
  },
  MARCH: {
    id: "MARCH",
    defaultMessage: "März",
  },
  APRIL: {
    id: "APRIL",
    defaultMessage: "April",
  },
  MAY: {
    id: "MAY",
    defaultMessage: "Mai",
  },
  JUNE: {
    id: "JUNE",
    defaultMessage: "Juni",
  },
  JULY: {
    id: "JULY",
    defaultMessage: "Juli",
  },
  AUGUST: {
    id: "AUGUST",
    defaultMessage: "August",
  },
  SEPTEMBER: {
    id: "SEPTEMBER",
    defaultMessage: "September",
  },
  OCTOBER: {
    id: "OCTOBER",
    defaultMessage: "Oktober",
  },
  NOVEMBER: {
    id: "NOVEMBER",
    defaultMessage: "November",
  },
  DECEMBER: {
    id: "DECEMBER",
    defaultMessage: "Dezember",
  },
  MONTH: {
    id: "MONTH",
    defaultMessage: "Monate",
  },
  YEAR: {
    id: "YEAR",
    defaultMessage: "Jahr",
  },
  CREATE_CLASSROOM: {
    id: "CREATE_CLASSROOM",
    defaultMessage: "Einen Kurs hinzufügen",
  },
  EDIT_CLASSROOM: {
    id: "EDIT_CLASSROOM",
    defaultMessage: "Einen Kurs bearbeiten",
  },
  CREATE_CLASSROOM_NAME: {
    id: "CREATE_CLASSROOM_NAME",
    defaultMessage: "Name des Kurses",
  },
  CREATE_CLASSROOM_SUBJECT: {
    id: "CREATE_CLASSROOM_SUBJECT",
    defaultMessage: "Unterrichtsfach",
  },
  CREATE_CLASSROOM_NAME_ERROR_MSG: {
    id: "CREATE_CLASSROOM_NAME_ERROR_MSG",
    defaultMessage: "Bitte geben Sie einen gültigen Kursnamen ein",
  },
  CREATE_CLASSROOM_SUBJECT_ERROR_MSG: {
    id: "CREATE_CLASSROOM_SUBJECT_ERROR_MSG",
    defaultMessage: "Bitte geben Sie ein gültiges Unterrichtsfach ein",
  },
  CREATE_CLASSROOM_SCHOOLYEAR_ERROR_MSG: {
    id: "CREATE_CLASSROOM_SCHOOLYEAR_ERROR_MSG",
    defaultMessage: "Bitte geben Sie ein gültiges Schuljahr ein",
  },
  CREATE: {
    id: "CREATE",
    defaultMessage: "Hinzufügen",
  },
  CANCEL: {
    id: "CANCEL",
    defaultMessage: "Abbrechen",
  },
  CREATE_STUDENT: {
    id: "CREATE_STUDENT",
    defaultMessage: "Schüler*innen hinzufügen",
  },
  UPDATE_STUDENT: {
    id: "UPDATE_STUDENT",
    defaultMessage: "Schüler*innen bearbeiten",
  },
  CREATE_STUDENT_HINT_TEXT: {
    id: "CREATE_STUDENT_HINT_TEXT",
    defaultMessage: `Die Schüler*innen werden Teil vom Kurs`,
    composedMessage: function (text: string) {
      return (
        <div>
          <div className="mb-2">
            Die Schüler*innen werden Teil vom Kurs{" "}
            <span className="secondary-color">{text}</span> sein.
          </div>
          <div>
            Tragen Sie die SchülerInnen-Namen nach Muster Vorname - Nachname
            ein.
          </div>
        </div>
      );
    },
  },
  CREATE_STUDENT_SORTING_EXPLANATION_TEXT: {
    id: "CREATE_STUDENT_SORTING_EXPLANATION_TEXT",
    defaultMessage:
      "Sie entscheiden, ob Sie Vor- und Nachname ihrer Schüler*Innen eintragen oder sich auf die Vornamen oder z.B. den Vornamen und das Initial des Nachnamens beschränken. In der Kursliste werden die Schüler*Innen alphabetisch nach ihren Nachnamen bzw. Initialen sortiert, sofern diese vorhanden sind. Falls nicht, sortieren wir alphabetisch nach den Vornamen.  Damit die Reihenfolge Ihrer Kursliste entspricht, achten Sie bitte darauf, die Namen nach einem einheitlichen Muster einzutragen.",
    composedMessage: function () {
      return (
        <div>
          <div className="mb-2">
            Sie entscheiden, ob Sie Vor- und Nachname ihrer Schüler*Innen
            eintragen oder sich auf die Vornamen oder z.B. den Vornamen und das
            Initial des Nachnamens beschränken.
          </div>
          <div className="mb-2">
            In der Kursliste werden die Schüler*Innen alphabetisch nach ihren
            Nachnamen bzw. Initialen sortiert, sofern diese vorhanden sind.
            Falls nicht, sortieren wir alphabetisch nach den Vornamen.
          </div>
          <div>
            Damit die Reihenfolge Ihrer Kursliste entspricht, achten Sie bitte
            darauf, die Namen nach einem einheitlichen Muster einzutragen.
          </div>
        </div>
      );
    },
  },
  FOR_INSTANCE_SHORCUT: {
    id: "FOR_INSTANCE_SHORCUT",
    defaultMessage: "z.B.",
  },
  CREATE_STUDENT_NAME_ERROR_MSG: {
    id: "CREATE_STUDENT_NAME_ERROR_MSG",
    defaultMessage:
      "Bitte geben Sie einen gültigen Namem der/des Schüler*in ein",
  },
  STUDENT_NAME: {
    id: "STUDENT_NAME",
    defaultMessage: "Name der Schüler*in",
  },
  SAVE: {
    id: "SAVE",
    defaultMessage: "Speichern",
  },
  OBSERVATIONS: {
    id: "OBSERVATIONS",
    defaultMessage: "Beobachtungen",
  },
  OBSERVATIONS_TEXT: {
    id: "OBSERVATIONS_TEXT",
    defaultMessage: "Text",
  },
  OBSERVATIONS_TEXT_HINT: {
    id: "OBSERVATIONS_TEXT_HINT",
    defaultMessage: "Hier haben Sie Platz für Ihre Notizen.",
  },
  NO_CLASSROOMS: {
    id: "NO_CLASSROOMS",
    defaultMessage: "Es gibt noch keine Kurse",
  },
  ADD_FIRST_CLASROOM: {
    id: "ADD_FIRST_CLASROOM",
    defaultMessage: "Fangen Sie jetzt damit an, Ihren ersten Kurs zu erstellen",
  },
  ADD_FIRST_CLASROOM_BUTTON: {
    id: "ADD_FIRST_CLASROOM_BUTTON",
    defaultMessage: "Ersten Kurs hinzufügen",
  },
  NO_STUDENTS: {
    id: "NO_STUDENTS",
    defaultMessage: "Es gibt noch keine Schüler*innen",
  },
  ADD_FIRST_STUDENT: {
    id: "ADD_FIRST_STUDENT",
    defaultMessage:
      "Fangen Sie jetzt damit an, Ihre*n erste*n Schüler*in hinzuzufügen",
  },
  ADD_FIRST_STUDENT_BUTTON: {
    id: "ADD_FIRST_STUDENT_BUTTON",
    defaultMessage: "Fügen Sie den/die erste*n Schüler*in hinzu",
  },
  NO_STUDENT_DATA: {
    id: "NO_STUDENT_DATA",
    defaultMessage: "Es gibt noch keine Daten für diese*n Schüler*in",
  },
  START_CREATING_QUALIFICATION: {
    id: "START_CREATING_QUALIFICATION",
    defaultMessage:
      "Fangen Sie an, Bewertungen für Ihre Schüler*innen anzulegen, um eine Gesamtbewertung und einen Überblick über monatliche Bewertungen zu erhalten.",
    composedHtmlMessage: (
      <div>
        Fangen Sie an, Bewertungen für Ihre Schüler*innen anzulegen, um{" "}
        <b className="secondary-color">eine Gesamtbewertung</b> und{" "}
        <b className="secondary-color">
          einen Überblick über monatliche Bewertungen
        </b>{" "}
        zu erhalten
      </div>
    ),
  },
  ARE_YOU_SURE_REMOVE_QUALIFICATION: {
    id: "ARE_YOU_SURE_REMOVE_QUALIFICATION",
    defaultMessage:
      "Sind Sie sicher, dass Sie diese Bewertung löschen möchten?",
  },
  ARE_YOU_SURE_REMOVE_ITEM: {
    id: "ARE_YOU_SURE_REMOVE_ITEM",
    defaultMessage: "Sind Sie sicher, dass Sie diese Item löschen möchten?.",
  },
  ARE_YOU_SURE_REMOVE_CLASSROM: {
    id: "ARE_YOU_SURE_REMOVE_CLASSROM",
    defaultMessage: "Sind Sie sicher, dass Sie diesen Kurse löschen möchten?",
  },
  ARE_YOU_SURE_REMOVE_STUDENT: {
    id: "ARE_YOU_SURE_REMOVE_STUDENT",
    defaultMessage:
      "Sind Sie sicher, dass Sie diese Schüler*in löschen möchten?",
  },
  REMOVE_CLASSROOM: {
    id: "REMOVE_CLASSROOM",
    defaultMessage: "Kurs löschen",
  },
  YOU_WILL_LOSE_DATA: {
    id: "YOU_WILL_LOSE_DATA",
    defaultMessage: "Sie werden alle eingetragenen Bewertungen verlieren.",
  },
  YOU_WILL_LOSE_STUDENT: {
    id: "YOU_WILL_LOSE_STUDENT",
    defaultMessage: "Die eingetragenen Bewertung geht verloren.",
  },
  THIS_CANT_UNDONE: {
    id: "THIS_CANT_UNDONE",
    defaultMessage: "Dies kann nicht rückgängig gemacht werden.",
  },
  TO_CONFIRM_DELETION: {
    id: "TO_CONFIRM_DELETION",
    defaultMessage:
      "Um den/die Schüler*in wirklich zu löschen, tippen Sie {} in das Textfeld.",
    composedMessage: function (text: string) {
      return (
        <div>
          Um den/die Schüler*in wirklich zu löschen, tippen Sie{" "}
          <b className="secondary-color">
            <i>{text}</i>
          </b>{" "}
          in das Textfeld.
        </div>
      );
    },
  },
  TO_CONFIRM_DELETION_CLASSROOM: {
    id: "TO_CONFIRM_DELETION_CLASSROOM",
    defaultMessage:
      "Um den Kurs wirklich zu löschen, tippen Sie {} in das Textfeld.",
    composedMessage: function (text: string) {
      return (
        <div>
          Um den Kurs wirklich zu löschen, tippen Sie{" "}
          <b className="secondary-color">
            <i>{text}</i>
          </b>{" "}
          in das Textfeld.
        </div>
      );
    },
  },
  DELETE_VERIFICATION_INPUT_MSG: {
    id: "DELETE_VERIFICATION_INPUT_MSG",
    defaultMessage: "Bitte geben Sie einen gültigen Bestätigungstext ein",
  },
  VERIFICATION_TEXT: {
    id: "VERIFICATION_TEXT",
    defaultMessage: "Bestätigungstext",
  },
  REMOVE_STUDENT_QUALIFICATION: {
    id: "REMOVE_STUDENT_QUALIFICATION",
    defaultMessage: "Bewertung löschen",
  },
  DATA_LOST_FOR_STUDENT: {
    id: "DATA_LOST_FOR_STUDENT",
    defaultMessage:
      "Die Eingabe für Student Wird gelöscht, ebenso mögliche Bemerkungen. Sie können dies nicht rückgängig machen.",
    composedMessage: function (text: string) {
      return (
        <div>
          Die Eingabe für{" "}
          <b className="secondary-color">
            <i>{text}</i>
          </b>{" "}
          wird gelöscht, ebenso mögliche Bemerkungen.
        </div>
      );
    },
  },
  PARTICIPATION_INFO: {
    id: "PARTICIPATION_INFO",
    defaultMessage: "Erneut klicken, um 0 Sterne zu vergeben",
  },
  EMAIL: {
    id: "EMAIL",
    defaultMessage: "E-Mail",
  },
  PASSWORD: {
    id: "PASSWORD",
    defaultMessage: "Passwort",
  },
  LOGIN: {
    id: "LOGIN",
    defaultMessage: "Login",
  },
  SIGNUP: {
    id: "SIGNUP",
    defaultMessage: "Anmelden",
  },
  EMAIL_LOGIN_ERROR_TEXT: {
    id: "EMAIL_LOGIN_ERROR_TEXT",
    defaultMessage: "Bitte geben Sie eine gültige E-mail-Adresse ein",
  },
  PASSWORD_LOGIN_ERROR_TEXT: {
    id: "PASSWORD_LOGIN_ERROR_TEXT",
    defaultMessage: "Bitte geben Sie ein gültiges Passwort ein",
  },
  NAME_LOGIN_ERROR_TEXT: {
    id: "NAME_LOGIN_ERROR_TEXT",
    defaultMessage: "Bitte geben Sie Ihren Namen ein",
  },
  LOGIN_SUCCESS_TEXT: {
    id: "LOGIN_SUCCESS_TEXT",
    defaultMessage: "Login erfolgreich",
  },
  LOGIN_ERROR_PASSWORD_TEXT: {
    id: "LOGIN_ERROR_PASSWORD_TEXT",
    defaultMessage: "Falsches Passwort",
  },
  NO_USER_EMAIL: {
    id: "NO_USER_EMAIL",
    defaultMessage: "Kein Nutzerkonto mit dieser E-Mail-Adresse",
  },
  TEXT: {
    id: "TEXT",
    defaultMessage: "text",
  },
  BACK_TO_LOGIN: {
    id: "BACK_TO_LOGIN",
    defaultMessage: "Zurück zum Login",
  },
  YOUR_NAME: {
    id: "YOUR_NAME",
    defaultMessage: "Nutzername",
  },
  SIGNIP_SUCCESS_TEXT: {
    id: "SIGNIP_SUCCESS_TEXT",
    defaultMessage: "Anmeldung erfolgreich",
  },
  TITLE_SIGNUP: {
    id: "TITLE_SIGNUP",
    defaultMessage: "Anmeldung",
  },
  CLASSTROOMS_TITLE: {
    id: "CLASSTROOMS_TITLE",
    defaultMessage: "Schuljahr",
  },
  CREATE_CLASSROOM_SUCCESS: {
    id: "CREATE_CLASSROOM_SUCCESS",
    defaultMessage: "Kurs erfolgreich angelegt.",
  },
  CREATE_CLASSROOM_ERROR: {
    id: "CREATE_CLASSROOM_ERROR",
    defaultMessage:
      "Beim Erstellen des Kurses ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_CLASSROOM_SUCCESS: {
    id: "UPDATE_CLASSROOM_SUCCESS",
    defaultMessage: "Kurs erfolgreich bearbeitet.",
  },
  UPDATE_CLASSROOM_ERROR: {
    id: "UPDATE_CLASSROOM_ERROR",
    defaultMessage:
      "Beim Bearbeiten des Kurses ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  DELETE_CLASSROOM_SUCCESS: {
    id: "DELETE_CLASSROOM_SUCCESS",
    defaultMessage: "Kurs erfolgreich gelöscht.",
  },
  DELETE_CLASSROOM_ERROR: {
    id: "DELETE_CLASSROOM_ERROR",
    defaultMessage:
      "Beim Löschen des Kurses ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_CLASSROOM_OBSERVATION_SUCCESS: {
    id: "UPDATE_CLASSROOM_OBSERVATION_SUCCESS",
    defaultMessage: "Bemerkung erfolgreich bearbeitet.",
  },
  UPDATE_CLASSROOM_OBSERVATION_ERROR: {
    id: "UPDATE_CLASSROOM_OBSERVATION_ERROR",
    defaultMessage:
      "Beim Bearbeiten der Bemerkung ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  CREATE_STUDENT_SUCCESS: {
    id: "CREATE_STUDENT_SUCCESS",
    defaultMessage: "SchülerIn wurde erfolgreich angelegt.",
  },
  CREATE_STUDENTS_SUCCESS: {
    id: "CREATE_STUDENTS_SUCCESS",
    defaultMessage: "Schüler*Innen wurden erfolgreich angelegt.",
  },
  CREATE_STUDENT_ERROR: {
    id: "CREATE_STUDENT_ERROR",
    defaultMessage:
      "Beim Erstellen der/des SchülerIn  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_STUDENT_SUCCESS: {
    id: "UPDATE_STUDENT_SUCCESS",
    defaultMessage: "SchülerIn wurde erfolgreich bearbeitet.",
  },
  UPDATE_STUDENT_ERROR: {
    id: "UPDATE_STUDENT_ERROR",
    defaultMessage:
      "Beim Bearbeiten der/des SchülerIn  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  DELETE_STUDENT_SUCCESS: {
    id: "DELETE_STUDENT_SUCCESS",
    defaultMessage: "SchülerIn wurde erfolgreich gelöscht.",
  },
  DELETE_STUDENT_ERROR: {
    id: "DELETE_STUDENT_ERROR",
    defaultMessage:
      "Beim Löschen des/der SchülerIn ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  REMOVE_QUALIFICATION_SUCCESS: {
    id: "REMOVE_QUALIFICATION_SUCCESS",
    defaultMessage: "Bewertung wurde erfolgreich gelöscht.",
  },
  REMOVE_QUALIFICATION_ERROR: {
    id: "REMOVE_QUALIFICATION_ERROR",
    defaultMessage:
      "Beim Löschen der Bewertung ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_STUDENT_OBSERVATION_SUCCESS: {
    id: "UPDATE_STUDENT_OBSERVATION_SUCCESS",
    defaultMessage: "Bemerkung wurde erfolgreich bearbeitet.",
  },
  UPDATE_STUDENT_OBSERVATION_ERROR: {
    id: "UPDATE_STUDENT_OBSERVATION_ERROR",
    defaultMessage:
      "Beim Bearbeiten der Bemerkung ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_BULK_SWITCH_SUCCESS: {
    id: "UPDATE_BULK_SWITCH_SUCCESS",
    defaultMessage:
      "Der Hausaufgaben-Status aller Schüler*Innen wurden erfolgreich aktualisiert.",
  },
  UPDATE_BULK_SWITCH_ERROR: {
    id: "UPDATE_BULK_SWITCH_ERROR",
    defaultMessage:
      "Beim Aktualisieren des Hausaufgaben-Status  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_STUDENT_QUALIFICATION_ERROR: {
    id: "UPDATE_STUDENT_QUALIFICATION_ERROR",
    defaultMessage:
      "Beim Bearbeiten der Bewertung  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_STUDENT_ATTENDANCE_ERROR: {
    id: "UPDATE_STUDENT_ATTENDANCE_ERROR",
    defaultMessage:
      "Beim Bearbeiten der Anwesenheit  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_STUDENT_HOMEWORK_ERROR: {
    id: "UPDATE_STUDENT_HOMEWORK_ERROR",
    defaultMessage:
      "Beim Aktualisieren des Hausaufgaben-Status  ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  UPDATE_LANGUAGE_SUCCESS: {
    id: "UPDATE_LANGUAGE_SUCCESS",
    defaultMessage: "Die NutzerInnen-Sprache wurde erfolgreich ausgewählt.",
  },
  UPDATE_LANGUAGE_ERROR: {
    id: "UPDATE_LANGUAGE_ERROR",
    defaultMessage:
      "Beim Auswählen der NutzerInnen-Sprache ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
  },
  OPTIONAL: {
    id: "OPTIONAL",
    defaultMessage: "Optional",
  },
  OPTIONAL_CLASSROOM_STUDENTS_TEXT: {
    id: "OPTIONAL_CLASSROOM_STUDENTS_TEXT",
    defaultMessage:
      "Wählen Sie einen bestehenden Kurs aus, um automatisch alle Schüler*Innen aus diesem Kurs in Ihren neuen Kurs zu übertragen",
  },
  HOMEWORK_BULK_SELECTION_TITLE: {
    id: "HOMEWORK_BULK_SELECTION_TITLE",
    defaultMessage: "Hausaufgaben gruppenweise eintragen",
  },
  HOMEWORK_BULK_SELECTION_BODY_TEXT: {
    id: "HOMEWORK_BULK_SELECTION_BODY_TEXT",
    defaultMessage:
      "Achtung: Es wird der Hausaufgaben-Status aller Schüler*Innen aktualisiert. Dieser kann im Nachhinein manuell für einzelne Schüler*Innen angepasst werden.",
  },
  CONFIRM: {
    id: "CONFIRM",
    defaultMessage: "Bestätigen",
  },
  CLASSROOM_OBSERVATION_TITLE: {
    id: "CLASSROOM_OBSERVATION_TITLE",
    defaultMessage: "Bemerkungen zum Kurs",
  },
  CLASSROOM_OBSERVATION_BODY: {
    id: "CLASSROOM_OBSERVATION_BODY",
    defaultMessage:
      "Es ist Platz für all Ihre Notizen. Notieren Sie zum Beispiel, wofür Sie Sterne vergeben, welche Schüler*innen im E- oder G-Kurs sind oder welche Nachteilsausgleiche zu beachten sind.",
  },
  STUDENT_OBSERVATION_TITLE: {
    id: "STUDENT_OBSERVATION_TITLE",
    defaultMessage: "Bemerkungen zum/zur Schüler*in",
  },
  STUDENT_OBSERVATION_BODY: {
    id: "STUDENT_OBSERVATION_BODY",
    defaultMessage:
      "Es ist Platz für all Ihre Notizen. Notieren Sie zum Beispiel Absprachen, die Sie mit dem/der Schüler*in getroffen, Notenstände, die Sie rückgemeldet oder Feedback, dass Sie ihm oder ihr gegeben haben.",
  },
  DAY_CLASS_OBSERVATION_TITLE: {
    id: "DAY_CLASS_OBSERVATION_TITLE",
    defaultMessage: "Bemerkungen zum/zur Schüler*in in dieser Stunde",
  },
  DAY_CLASS_OBSERVATION_BODY: {
    id: "DAY_CLASS_OBSERVATION_BODY",
    defaultMessage:
      "Es ist Platz für all Ihre Notizen. Die Bemerkung wird neben der Bewertung des/der Schüler*in für diesen Tag angezeigt. Notieren Sie zum Beispiel, ob die Arbeitszeit genutzt, der Unterricht gestört oder gut im Team gearbeitet wurde.",
  },
  FORGOT_PASSWORD: {
    id: "FORGOT_PASSWORD",
    defaultMessage: "Passwort vergessen",
  },
  RESET_YOUR_PASSWORD: {
    id: "RESET_YOUR_PASSWORD",
    defaultMessage: "Setzen Sie Ihr Passwort zurück",
  },
  CONTINUE: {
    id: "CONTINUE",
    defaultMessage: "Weiter",
  },
  FORGOT_PASS_TEXT_INFO: {
    id: "FORGOT_PASS_TEXT_INFO",
    defaultMessage:
      "Geben Sie die E-Mail-Adresse Ihres Benutzerkontos ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
  },
  TRY_AGAIN: {
    id: "TRY_AGAIN",
    defaultMessage:
      "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
  },
  EMAIL_SENT: {
    id: "EMAIL_SENT",
    defaultMessage: "E-Mail zum Zurücksetzen des Passworts wurde gesendet.",
  },
  EMAIL_SENT_SUCCESS: {
    id: "EMAIL_SENT_SUCCESS",
    defaultMessage: "Email wurde erfolgreich versendet.",
  },
  CHECK_INBOX: {
    id: "CHECK_INBOX",
    defaultMessage: "Bitte überprüfen Sie Ihren E-Mail-Posteingang.",
  },
  PASS_NOT_MATCH: {
    id: "PASS_NOT_MATCH",
    defaultMessage: "Passwörter stimmen nicht überein.",
  },
  PASS_UPDATED: {
    id: "PASS_UPDATED",
    defaultMessage: "Passwort erfolgreich aktualisiert.",
  },
  PASS_UPDATED_EXPIRED: {
    id: "PASS_UPDATED_EXPIRED",
    defaultMessage:
      "Der Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte versuchen Sie es erneut.",
  },
  EMAIL_NOT_EXIST: {
    id: "EMAIL_NOT_EXIST",
    defaultMessage: "Die E-Mail-Adresse des Benutzers ist nicht vorhanden.",
  },
  SKIP: {
    id: "SKIP",
    defaultMessage: "Überspringen",
  },
  BACK: {
    id: "BACK",
    defaultMessage: "Zurück",
  },
  INSTALL_APP_STEP_0: {
    id: "INSTALL_APP_STEP_0",
    defaultMessage:
      "Halten Sie TutoriFy★ immer griffbereit! Fügen Sie unsere App zu Ihrem Startbildschirm hinzu, um jederzeit schnell und einfach darauf zugreifen zu können.",
  },
  INSTALL_APP_STEP_1_SAFARI: {
    id: "INSTALL_APP_STEP_1_SAFARI",
    defaultMessage:
      "Im Safari-Browser tippen Sie auf das Teilen-Symbol in der unteren Navigationsleiste:",
  },
  INSTALL_APP_STEP_1_FIREFOX: {
    id: "INSTALL_APP_STEP_1_FIREFOX",
    defaultMessage:
      "Im Firefox-Browser tippen Sie auf das Menüsymbol (drei vertikale Punkte) in der unteren rechten Ecke:",
  },
  INSTALL_APP_STEP_1_CHROME: {
    id: "INSTALL_APP_STEP_1_CHROME",
    defaultMessage:
      "Im Chrome-Browser tippen Sie auf das Menüsymbol (drei vertikale Punkte) in der oberen rechten Ecke:",
  },
  INSTALL_APP_STEP_2_SAFARI: {
    id: "INSTALL_APP_STEP_2_SAFARI",
    defaultMessage:
      "Scrollen Sie im Teilen-Menü und wählen Sie 'Zum Home-Bildschirm':",
  },
  INSTALL_APP_STEP_2_FIREFOX: {
    id: "INSTALL_APP_STEP_2_FIREFOX",
    defaultMessage: "Wählen Sie 'Installieren':",
  },
  INSTALL_APP_STEP_2_CHROME: {
    id: "INSTALL_APP_STEP_2_CHROME",
    defaultMessage: "Wählen Sie 'App installieren':",
  },
  INSTALL_APP_STEP_3_SAFARI: {
    id: "INSTALL_APP_STEP_3_SAFARI",
    defaultMessage: "Tippen Sie dann oben rechts auf 'Hinzufügen'.",
  },
  INSTALL_APP_STEP_3_FIREFOX: {
    id: "INSTALL_APP_STEP_3_FIREFOX",
    defaultMessage: "Tippen Sie auf 'Hinzufügen'.",
  },
  INSTALL_APP_STEP_3_CHROME: {
    id: "INSTALL_APP_STEP_3_CHROME",
    defaultMessage: "Tippen Sie auf 'Installieren'.",
  },
  INSTALL_APP_STEP_3_SUCCESS: {
    id: "INSTALL_APP_STEP_3_SUCCESS",
    defaultMessage:
      "Und das war es! TutoriFy★ befindet sich jetzt auf Ihrem Startbildschirm.",
  },
  APP_INSTALL: {
    id: "APP_INSTALL",
    defaultMessage: "App installieren",
  },
  LATER: {
    id: "LATER",
    defaultMessage: "Später",
  },
  INSTALL_APP_STEP_4: {
    id: "INSTALL_APP_STEP_4",
    defaultMessage:
      "Sie können die Informationen zur App-Installation erneut anzeigen, indem Sie auf das Menüsymbol klicken",
  },
  DONE: {
    id: "DONE",
    defaultMessage: "Erledigt",
  },
  UNDONE: {
    id: "UNDONE",
    defaultMessage: "unerledigt",
  },
  NONE: {
    id: "NONE",
    defaultMessage: "Keiner",
  },
  NAME: {
    id: "NAME",
    defaultMessage: "Name",
  },
  TRACKIFY: {
    id: "TRACKIFY",
    defaultMessage: "Trackify",
  },
  TRACKIFY_CLASSES: {
    id: "TRACKIFY_CLASSES",
    defaultMessage: "Kurse",
  },
  TRACKIFY_GRADES: {
    id: "TRACKIFY_GRADES",
    defaultMessage: "Noten",
  },
  TRACKIFY_QUARTER: {
    id: "TRACKIFY_QUARTER",
    defaultMessage: "Quartal",
  },
  TRACKIFY_HALBJAHR: {
    id: "TRACKIFY_HALBJAHR",
    defaultMessage: "Halbjahr",
  },
  TRACKIFY_ZEUGNIS: {
    id: "TRACKIFY_ZEUGNIS",
    defaultMessage: "Zeugnis",
  },
  TRACKIFY_SCHRIFTLICH: {
    id: "TRACKIFY_SCHRIFTLICH",
    defaultMessage: "Schriftlich",
  },
  TRACKIFY_MUENDLICH: {
    id: "TRACKIFY_MUENDLICH",
    defaultMessage: "Mündlich",
  },
  TRACKIFY_AT: {
    id: "TRACKIFY_AT",
    defaultMessage: "Sonstige Mitarbeit",
  },
  TRACKIFY_NOTE: {
    id: "TRACKIFY_NOTE",
    defaultMessage: "Note",
  },
  TRACKIFY_NOTENWERT: {
    id: "TRACKIFY_NOTENWERT",
    defaultMessage: "Notenwert",
  },
  TRACKIFY_SCHOOL_YEAR: {
    id: "TRACKIFY_SCHOOL_YEAR",
    defaultMessage: "Schuljahr",
  },
  TRACKIFY_CONFIG: {
    id: "TRACKIFY_CONFIG",
    defaultMessage: "Trackify Einstellungen",
  },
  TRACKIFY_KURS_TYPE: {
    id: "TRACKIFY_KURS_TYPE",
    defaultMessage: "Kursart",
  },
  TRACKIFY_KLASSE_LEVEL: {
    id: "TRACKIFY_KLASSE_LEVEL",
    defaultMessage: "Klassenstufe",
  },
  TRACKIFY_OBERSTUFE: {
    id: "TRACKIFY_OBERSTUFE",
    defaultMessage: "Oberstufe",
  },
  TRACKIFY_GERUNDET: {
    id: "TRACKIFY_GERUNDET",
    defaultMessage: "Gerundet",
  },
  TRACKIFY_E_KURS: {
    id: "TRACKIFY_E_KURS",
    defaultMessage: "E-Kurs",
  },
  TRACKIFY_G_KURS: {
    id: "TRACKIFY_G_KURS",
    defaultMessage: "G-Kurs",
  },
  TRACKIFY_IN_PROGRESS: {
    id: "TRACKIFY_IN_PROGRESS",
    defaultMessage: "in Bearbeitung",
  },
  TRACKIFY_GRADED: {
    id: "TRACKIFY_GRADED",
    defaultMessage: "bewertet",
  },
  TRACKIFY_PRINT: {
    id: "TRACKIFY_PRINT",
    defaultMessage: "Drucken",
  },
  TRACKIFY_NO_VALUE: {
    id: "TRACKIFY_NO_VALUE",
    defaultMessage: "ohne",
  },
  SHOW_MORE: {
    id: "SHOW_MORE",
    defaultMessage: "Mehr anzeigen",
  },
  SHOW_LESS: {
    id: "SHOW_LESS",
    defaultMessage: "Weniger anzeigen",
  },
  TRACKIFY_INCOMPLETE: {
    id: "TRACKIFY_INCOMPLETE",
    defaultMessage: "unvollständig",
  },
  TRACKIFY_AVERAGE: {
    id: "TRACKIFY_AVERAGE",
    defaultMessage: "Durchschnitt",
  },
  TRACKIFY_TREND: {
    id: "TRACKIFY_TREND",
    defaultMessage: "Trend",
  },
  TRACKIFY_EXPORT_CSV: {
    id: "TRACKIFY_EXPORT_CSV",
    defaultMessage: "CSV exportieren",
  },
  TRACKIFY_EXPORT_EXCEL: {
    id: "TRACKIFY_EXPORT_EXCEL",
    defaultMessage: "Excel exportieren",
  },
  TRACKIFY_TEST_AVG: {
    id: "TRACKIFY_TEST_AVG",
    defaultMessage: "T∅",
  },
  TRACKIFY_NONE_LABEL: {
    id: "TRACKIFY_NONE_LABEL",
    defaultMessage: "Allgemein (ohne Kurstyp)",
  },
  TRACKIFY_GK_LABEL: {
    id: "TRACKIFY_GK_LABEL",
    defaultMessage: "GK (Grundkurs)",
  },
  TRACKIFY_LK_LABEL: {
    id: "TRACKIFY_LK_LABEL",
    defaultMessage: "LK (Leistungskurs)",
  },
  TRACKIFY_KLASSE: {
    id: "TRACKIFY_KLASSE",
    defaultMessage: "Klasse",
  },
  TRACKIFY_WEIGHT_PRESET: {
    id: "TRACKIFY_WEIGHT_PRESET",
    defaultMessage: "Gewichtungs-Vorlage",
  },
  TRACKIFY_PRESET_BERLIN: {
    id: "TRACKIFY_PRESET_BERLIN",
    defaultMessage: "Berlin Sek I",
  },
  TRACKIFY_PRESET_CUSTOM: {
    id: "TRACKIFY_PRESET_CUSTOM",
    defaultMessage: "Benutzerdefiniert",
  },
  TRACKIFY_WEIGHT_KA_LEK: {
    id: "TRACKIFY_WEIGHT_KA_LEK",
    defaultMessage: "KA / LEK",
  },
  TRACKIFY_WEIGHT_MUENDLICH_TESTS: {
    id: "TRACKIFY_WEIGHT_MUENDLICH_TESTS",
    defaultMessage: "Mündl. / Tests",
  },
  TRACKIFY_WEIGHT_SCHRIFTLICH_AT: {
    id: "TRACKIFY_WEIGHT_SCHRIFTLICH_AT",
    defaultMessage: "Schriftlich / AT",
  },
  TRACKIFY_WEIGHT_OBERSTUFE_SCHRIFTLICH_AT: {
    id: "TRACKIFY_WEIGHT_OBERSTUFE_SCHRIFTLICH_AT",
    defaultMessage: "Oberstufe Schr. / AT",
  },
  TRACKIFY_TOOLTIP_KA: {
    id: "TRACKIFY_TOOLTIP_KA",
    defaultMessage: "Klassenarbeit",
  },
  TRACKIFY_TOOLTIP_LEK: {
    id: "TRACKIFY_TOOLTIP_LEK",
    defaultMessage: "Lernerfolgskontrolle",
  },
  TRACKIFY_TOOLTIP_SCHRIFTLICH: {
    id: "TRACKIFY_TOOLTIP_SCHRIFTLICH",
    defaultMessage: "Schriftliche Note (KA + LEK gewichtet)",
  },
  TRACKIFY_TOOLTIP_MUENDLICH: {
    id: "TRACKIFY_TOOLTIP_MUENDLICH",
    defaultMessage: "Mündliche Beteiligungsnote",
  },
  TRACKIFY_TOOLTIP_TEST: {
    id: "TRACKIFY_TOOLTIP_TEST",
    defaultMessage: "Test",
  },
  TRACKIFY_TOOLTIP_TEST_AVG: {
    id: "TRACKIFY_TOOLTIP_TEST_AVG",
    defaultMessage: "Testdurchschnitt",
  },
  TRACKIFY_TOOLTIP_AT: {
    id: "TRACKIFY_TOOLTIP_AT",
    defaultMessage: "Allgemeiner Teil (Mündlich + Tests)",
  },
  TRACKIFY_TOOLTIP_NOTENWERT: {
    id: "TRACKIFY_TOOLTIP_NOTENWERT",
    defaultMessage: "Notenwert (1 = sehr gut, 6 = ungenügend)",
  },
  TRACKIFY_TOOLTIP_EG: {
    id: "TRACKIFY_TOOLTIP_EG",
    defaultMessage: "E = Erweiterungskurs, G = Grundkurs",
  },
  TRACKIFY_TOOLTIP_GERUNDET: {
    id: "TRACKIFY_TOOLTIP_GERUNDET",
    defaultMessage: "Auf eine Dezimalstelle gerundet",
  },
  MODULES: {
    id: "MODULES",
    defaultMessage: "Module",
  },
  MODULE_PARTICIFY_DESC: {
    id: "MODULE_PARTICIFY_DESC",
    defaultMessage: "Anwesenheit und Beteiligung erfassen",
  },
  MODULE_TRACKIFY_DESC: {
    id: "MODULE_TRACKIFY_DESC",
    defaultMessage: "Noten und Bewertungen verwalten",
  },
  MODULE_COMING_SOON: {
    id: "MODULE_COMING_SOON",
    defaultMessage: "Demnächst verfügbar",
  },
  TRACKIFY_BETA_TITLE: {
    id: "TRACKIFY_BETA_TITLE",
    defaultMessage: "Experimentell",
  },
  TRACKIFY_BETA_DESC: {
    id: "TRACKIFY_BETA_DESC",
    defaultMessage: "Dieses Modul ist neu und wird aktiv weiterentwickelt. Feedback ist willkommen an",
  },
  TRACKIFY_CONFIG_SAVE_ERROR: {
    id: "TRACKIFY_CONFIG_SAVE_ERROR",
    defaultMessage: "Einstellungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
  },
  WHATS_NEW_TITLE: {
    id: "WHATS_NEW_TITLE",
    defaultMessage: "Neu in TutoriFy",
  },
  WHATS_NEW_BODY: {
    id: "WHATS_NEW_BODY",
    defaultMessage: "Jede Klasse hat jetzt einen Modul-Hub. Klicke auf eine Klasse, um alle verf\u00FCgbaren Module zu sehen.",
  },
  WHATS_NEW_TRACKIFY: {
    id: "WHATS_NEW_TRACKIFY",
    defaultMessage: "Die Noten Ihrer Sch\u00FCler*innen, nach Bewertung organisiert. CSV-Export f\u00FCr Ihre Schule.",
  },
  WHATS_NEW_CALENDFY: {
    id: "WHATS_NEW_CALENDFY",
    defaultMessage: "Ihr Stundenplan mit Erinnerungen. TutoriFy weiß, wann Sie unterrichten.",
  },
  WHATS_NEW_NOTIFY: {
    id: "WHATS_NEW_NOTIFY",
    defaultMessage: "Automatische E-Mail-Erinnerungen für Anwesenheit, Hausaufgaben, Noten und tägliche Zusammenfassungen.",
  },
  WHATS_NEW_LOGIFY: {
    id: "WHATS_NEW_LOGIFY",
    defaultMessage: "Beobachtungen mit Kategorien: Akademisch, Sozial, Verhalten. Ihr Unterrichtstagebuch.",
  },
  WHATS_NEW_REPORTIFY: {
    id: "WHATS_NEW_REPORTIFY",
    defaultMessage: "Automatische Berichte aus Ihren vorhandenen Daten. F\u00FCr den Elternabend, f\u00FCr Sie.",
  },
  FD_HOMEWORK_TIP: {
    id: "FD_HOMEWORK_TIP",
    defaultMessage: "Tipp: Gab es heute Hausaufgaben? Aktivieren Sie den Haken \u201EHomework\u201C oben, um zu erfassen, wer sie erledigt hat.",
  },
  FD_HOMEWORK_CTA: {
    id: "FD_HOMEWORK_CTA",
    defaultMessage: "Zeig mir",
  },
  FD_OBSERVATION_TIP: {
    id: "FD_OBSERVATION_TIP",
    defaultMessage: "M\u00F6chten Sie heute etwas zu einem Sch\u00FCler notieren? Klicken Sie auf \u201EObservation\u201C auf der Karte, um eine kurze Notiz hinzuzuf\u00FCgen.",
  },
  FD_OBSERVATION_CTA: {
    id: "FD_OBSERVATION_CTA",
    defaultMessage: "Verstanden",
  },
  FD_LOGIFY_TIP: {
    id: "FD_LOGIFY_TIP",
    defaultMessage: "Ihre Beobachtungen sind wertvoll! LogiFy erm\u00F6glicht es Ihnen, diese mit Kategorien (Akademisch, Sozial, Verhalten) zu strukturieren und die Entwicklung \u00FCber die Zeit zu verfolgen.",
  },
  FD_LOGIFY_CTA: {
    id: "FD_LOGIFY_CTA",
    defaultMessage: "LogiFy entdecken",
  },
  FD_TRACKIFY_TIP: {
    id: "FD_TRACKIFY_TIP",
    defaultMessage: "M\u00FCssen Sie Noten erfassen? TrackiFy erm\u00F6glicht es Ihnen, Bewertungen einzutragen und Durchschnitte automatisch berechnen zu lassen.",
  },
  FD_TRACKIFY_CTA: {
    id: "FD_TRACKIFY_CTA",
    defaultMessage: "TrackiFy ausprobieren",
  },
  FD_REPORTIFY_TIP: {
    id: "FD_REPORTIFY_TIP",
    defaultMessage: "Sie haben einen Monat lang Daten gesammelt! ReportiFy kann PDF-Berichte mit den Entwicklungen Ihrer Sch\u00FCler*innen erstellen \u2014 ideal f\u00FCr den Elternabend.",
  },
  FD_REPORTIFY_CTA: {
    id: "FD_REPORTIFY_CTA",
    defaultMessage: "Bericht erstellen",
  },
  MODULE_REPORTIFY_DESC: {
    id: "MODULE_REPORTIFY_DESC",
    defaultMessage: "PDF-Berichte und Analysen erstellen",
  },
  TRACKIFY_EMPTY_TITLE: {
    id: "TRACKIFY_EMPTY_TITLE",
    defaultMessage: "Noch keine Schüler*Innen",
  },
  TRACKIFY_EMPTY_DESC: {
    id: "TRACKIFY_EMPTY_DESC",
    defaultMessage: "Füge zuerst Schüler*Innen zu dieser Klasse in ParticiFy hinzu, dann komm hierher zurück, um ihre Noten zu verwalten.",
  },
  TRACKIFY_GO_TO_PARTICIFY: {
    id: "TRACKIFY_GO_TO_PARTICIFY",
    defaultMessage: "Zu ParticiFy",
  },
  FIRST_NAME: {
    id: "FIRST_NAME",
    defaultMessage: "Vorname",
  },
  LAST_NAME: {
    id: "LAST_NAME",
    defaultMessage: "Nachname",
  },
  JOB_TITLE: {
    id: "JOB_TITLE",
    defaultMessage: "Berufsbezeichnung",
  },
  BIO: {
    id: "BIO",
    defaultMessage: "Über mich",
  },
  CHANGE_PASSWORD: {
    id: "CHANGE_PASSWORD",
    defaultMessage: "Passwort ändern",
  },
  CURRENT_PASSWORD: {
    id: "CURRENT_PASSWORD",
    defaultMessage: "Aktuelles Passwort",
  },
  NEW_PASSWORD: {
    id: "NEW_PASSWORD",
    defaultMessage: "Neues Passwort",
  },
  UPDATE_PROFILE_SUCCESS: {
    id: "UPDATE_PROFILE_SUCCESS",
    defaultMessage: "Profil erfolgreich aktualisiert",
  },
  UPDATE_PROFILE_ERROR: {
    id: "UPDATE_PROFILE_ERROR",
    defaultMessage: "Fehler beim Aktualisieren des Profils, bitte versuche es erneut.",
  },
  UPDATE_PASSWORD_SUCCESS: {
    id: "UPDATE_PASSWORD_SUCCESS",
    defaultMessage: "Passwort erfolgreich aktualisiert",
  },
  UPDATE_PASSWORD_ERROR: {
    id: "UPDATE_PASSWORD_ERROR",
    defaultMessage: "Fehler beim Aktualisieren des Passworts, bitte versuche es erneut.",
  },
  CURRENT_PASSWORD_INCORRECT: {
    id: "CURRENT_PASSWORD_INCORRECT",
    defaultMessage: "Aktuelles Passwort ist falsch",
  },
  PASSWORD_MIN_LENGTH: {
    id: "PASSWORD_MIN_LENGTH",
    defaultMessage: "Das Passwort muss mindestens 6 Zeichen lang sein",
  },
  CALENDFY: {
    id: "CALENDFY",
    defaultMessage: "Kalender",
  },
  CALENDFY_EVENT: {
    id: "CALENDFY_EVENT",
    defaultMessage: "Termin",
  },
  CALENDFY_NEW_EVENT: {
    id: "CALENDFY_NEW_EVENT",
    defaultMessage: "Neuer Termin",
  },
  CALENDFY_EDIT_EVENT: {
    id: "CALENDFY_EDIT_EVENT",
    defaultMessage: "Termin bearbeiten",
  },
  CALENDFY_DELETE_EVENT: {
    id: "CALENDFY_DELETE_EVENT",
    defaultMessage: "Termin löschen",
  },
  CALENDFY_WEEK: {
    id: "CALENDFY_WEEK",
    defaultMessage: "Woche",
  },
  CALENDFY_DAY: {
    id: "CALENDFY_DAY",
    defaultMessage: "Tag",
  },
  CALENDFY_MONTH: {
    id: "CALENDFY_MONTH",
    defaultMessage: "Monat",
  },
  CALENDFY_RECURRING: {
    id: "CALENDFY_RECURRING",
    defaultMessage: "Wiederkehrende Regel",
  },
  CALENDFY_WIZARD: {
    id: "CALENDFY_WIZARD",
    defaultMessage: "Stundenplan-Assistent",
  },
  CALENDFY_CLASS: {
    id: "CALENDFY_CLASS",
    defaultMessage: "Unterricht",
  },
  CALENDFY_EXAM: {
    id: "CALENDFY_EXAM",
    defaultMessage: "Klausur",
  },
  CALENDFY_SPECIAL: {
    id: "CALENDFY_SPECIAL",
    defaultMessage: "Besonderes",
  },
  CALENDFY_HOLIDAY: {
    id: "CALENDFY_HOLIDAY",
    defaultMessage: "Frei",
  },
  CALENDFY_SUBSTITUTION: {
    id: "CALENDFY_SUBSTITUTION",
    defaultMessage: "Vertretung",
  },
  CALENDFY_OTHER: {
    id: "CALENDFY_OTHER",
    defaultMessage: "Sonstiges",
  },
  CALENDFY_NO_EVENTS: {
    id: "CALENDFY_NO_EVENTS",
    defaultMessage: "Keine Termine an diesem Tag",
  },
  CALENDFY_EVENT_CREATED: {
    id: "CALENDFY_EVENT_CREATED",
    defaultMessage: "Termin erstellt",
  },
  CALENDFY_EVENT_UPDATED: {
    id: "CALENDFY_EVENT_UPDATED",
    defaultMessage: "Termin aktualisiert",
  },
  CALENDFY_EVENT_DELETED: {
    id: "CALENDFY_EVENT_DELETED",
    defaultMessage: "Termin gelöscht",
  },
  CALENDFY_SCHEDULE_CREATED: {
    id: "CALENDFY_SCHEDULE_CREATED",
    defaultMessage: "Stundenplan erstellt!",
  },
  CALENDFY_RECURRING_ABBR: {
    id: "CALENDFY_RECURRING_ABBR",
    defaultMessage: "Wdh.",
  },
  CALENDFY_RECURRING_LABEL: {
    id: "CALENDFY_RECURRING_LABEL",
    defaultMessage: "Wiederkehrend",
  },
  CALENDFY_RECURRING_EVENT: {
    id: "CALENDFY_RECURRING_EVENT",
    defaultMessage: "Wiederkehrender Termin",
  },
  CALENDFY_EXPERIMENTAL: {
    id: "CALENDFY_EXPERIMENTAL",
    defaultMessage: "Experimentell",
  },
  CALENDFY_EXPERIMENTAL_DESC: {
    id: "CALENDFY_EXPERIMENTAL_DESC",
    defaultMessage: "Dieses Modul ist neu und wird aktiv weiterentwickelt. Dein Feedback ist willkommen unter",
  },
  EXPERIMENTAL_BANNER_TITLE: {
    id: "EXPERIMENTAL_BANNER_TITLE",
    defaultMessage: "{moduleName} — Experimentell",
  },
  EXPERIMENTAL_BANNER_DESCRIPTION: {
    id: "EXPERIMENTAL_BANNER_DESCRIPTION",
    defaultMessage: "Dieses Modul befindet sich noch in der Entwicklung. Deine Meinung z\u00e4hlt! Sag uns, was gut funktioniert, was fehlt oder was dich st\u00f6rt — so k\u00f6nnen wir {moduleName} f\u00fcr deinen Unterricht verbessern. Schreib uns an: {email}",
  },
  EXPERIMENTAL_BANNER_FEEDBACK: {
    id: "EXPERIMENTAL_BANNER_FEEDBACK",
    defaultMessage: "Feedback geben",
  },
  CALENDFY_TODAY: {
    id: "CALENDFY_TODAY",
    defaultMessage: "Heute",
  },
  CALENDFY_FILTER_BY: {
    id: "CALENDFY_FILTER_BY",
    defaultMessage: "Filtern nach:",
  },
  CALENDFY_ALL_CLASSES: {
    id: "CALENDFY_ALL_CLASSES",
    defaultMessage: "Alle Klassen",
  },
  CALENDFY_RULE_BUTTON: {
    id: "CALENDFY_RULE_BUTTON",
    defaultMessage: "Regel",
  },
  CALENDFY_ASSISTANT: {
    id: "CALENDFY_ASSISTANT",
    defaultMessage: "Assistent",
  },
  CALENDFY_EXPORT: {
    id: "CALENDFY_EXPORT",
    defaultMessage: "Export",
  },
  CALENDFY_DUPLICATE_EVENT: {
    id: "CALENDFY_DUPLICATE_EVENT",
    defaultMessage: "Termin duplizieren",
  },
  CALENDFY_ADJUST_DETAILS: {
    id: "CALENDFY_ADJUST_DETAILS",
    defaultMessage: "Passe die Termindetails an.",
  },
  CALENDFY_COPY_EVENT_DESC: {
    id: "CALENDFY_COPY_EVENT_DESC",
    defaultMessage: "Erstelle eine Kopie des Termins.",
  },
  CALENDFY_NEW_EVENT_DESC: {
    id: "CALENDFY_NEW_EVENT_DESC",
    defaultMessage: "Erstelle einen neuen Termin in deinem Kalender.",
  },
  CALENDFY_ERROR: {
    id: "CALENDFY_ERROR",
    defaultMessage: "Ein Fehler ist aufgetreten",
  },
  CALENDFY_EVENTS_DELETED: {
    id: "CALENDFY_EVENTS_DELETED",
    defaultMessage: "Termin(e) gelöscht",
  },
  CALENDFY_ALL_SERIES_UPDATED: {
    id: "CALENDFY_ALL_SERIES_UPDATED",
    defaultMessage: "Alle Termine der Serie aktualisiert",
  },
  CALENDFY_RECURRING_RULE_CREATED: {
    id: "CALENDFY_RECURRING_RULE_CREATED",
    defaultMessage: "Wiederkehrende Regel erstellt",
  },
  CALENDFY_RECURRING_RULE_DESC: {
    id: "CALENDFY_RECURRING_RULE_DESC",
    defaultMessage: "Erstelle eine Regel für wiederkehrende Termine.",
  },
  CALENDFY_DELETE_RECURRING_TITLE: {
    id: "CALENDFY_DELETE_RECURRING_TITLE",
    defaultMessage: "Wiederkehrenden Termin löschen",
  },
  CALENDFY_DELETE_RECURRING_DESC: {
    id: "CALENDFY_DELETE_RECURRING_DESC",
    defaultMessage: "Dieser Termin gehört zu einer wiederkehrenden Regel. Was möchten Sie löschen?",
  },
  CALENDFY_ONLY_THIS: {
    id: "CALENDFY_ONLY_THIS",
    defaultMessage: "Nur diesen Termin",
  },
  CALENDFY_THIS_AND_FUTURE: {
    id: "CALENDFY_THIS_AND_FUTURE",
    defaultMessage: "Diesen und zukünftige",
  },
  CALENDFY_ALL_IN_RULE: {
    id: "CALENDFY_ALL_IN_RULE",
    defaultMessage: "Alle Termine der Regel",
  },
  CALENDFY_EDIT_RECURRING_TITLE: {
    id: "CALENDFY_EDIT_RECURRING_TITLE",
    defaultMessage: "Wiederkehrenden Termin bearbeiten",
  },
  CALENDFY_EDIT_RECURRING_DESC: {
    id: "CALENDFY_EDIT_RECURRING_DESC",
    defaultMessage: "Dieser Termin gehört zu einer Serie. Möchtest du nur diesen oder alle Termine der Serie aktualisieren?",
  },
  CALENDFY_ALL_IN_SERIES: {
    id: "CALENDFY_ALL_IN_SERIES",
    defaultMessage: "Alle Termine der Serie",
  },
  CALENDFY_ALL_BLOCKED_DATE: {
    id: "CALENDFY_ALL_BLOCKED_DATE",
    defaultMessage: "Das Datum kann nur für diesen einzelnen Termin geändert werden",
  },
  CALENDFY_EVENTS_PLURAL: {
    id: "CALENDFY_EVENTS_PLURAL",
    defaultMessage: "Termine",
  },
  CALENDFY_EVENT_TYPE_SECTION: {
    id: "CALENDFY_EVENT_TYPE_SECTION",
    defaultMessage: "Art des Ereignisses",
  },
  CALENDFY_GENERAL_INFO: {
    id: "CALENDFY_GENERAL_INFO",
    defaultMessage: "Allgemeine Informationen",
  },
  CALENDFY_CLASSROOM: {
    id: "CALENDFY_CLASSROOM",
    defaultMessage: "Klasse",
  },
  CALENDFY_NO_CLASS: {
    id: "CALENDFY_NO_CLASS",
    defaultMessage: "Keine Klasse",
  },
  CALENDFY_SUBTITLE_LABEL: {
    id: "CALENDFY_SUBTITLE_LABEL",
    defaultMessage: "Untertitel (optional)",
  },
  CALENDFY_SUBTITLE_HELPER: {
    id: "CALENDFY_SUBTITLE_HELPER",
    defaultMessage: "Wird unter dem Klassennamen angezeigt",
  },
  CALENDFY_DATE: {
    id: "CALENDFY_DATE",
    defaultMessage: "Datum",
  },
  CALENDFY_TIME_START: {
    id: "CALENDFY_TIME_START",
    defaultMessage: "Von",
  },
  CALENDFY_TIME_END: {
    id: "CALENDFY_TIME_END",
    defaultMessage: "Bis",
  },
  CALENDFY_TIME_ERROR: {
    id: "CALENDFY_TIME_ERROR",
    defaultMessage: "Die Startzeit muss vor der Endzeit liegen.",
  },
  CALENDFY_PREPARATION: {
    id: "CALENDFY_PREPARATION",
    defaultMessage: "Vorbereitung / Unterrichtsplanung",
  },
  CALENDFY_PREP_HINT: {
    id: "CALENDFY_PREP_HINT",
    defaultMessage: "Plane deine Stunde: Themen, Aktivitäten, Materialien, Zeitstruktur...",
  },
  CALENDFY_TEMPLATES: {
    id: "CALENDFY_TEMPLATES",
    defaultMessage: "Vorlagen",
  },
  CALENDFY_ADD_BLOCKS: {
    id: "CALENDFY_ADD_BLOCKS",
    defaultMessage: "Bausteine hinzufügen",
  },
  CALENDFY_HOMEWORKS: {
    id: "CALENDFY_HOMEWORKS",
    defaultMessage: "Hausaufgaben",
  },
  CALENDFY_EXISTING: {
    id: "CALENDFY_EXISTING",
    defaultMessage: "Vorhandene",
  },
  CALENDFY_NEW_HOMEWORK: {
    id: "CALENDFY_NEW_HOMEWORK",
    defaultMessage: "Neue Hausaufgabe...",
  },
  CALENDFY_DAYS_OF_WEEK: {
    id: "CALENDFY_DAYS_OF_WEEK",
    defaultMessage: "Wochentage",
  },
  CALENDFY_DATE_RANGE: {
    id: "CALENDFY_DATE_RANGE",
    defaultMessage: "Zeitraum",
  },
  CALENDFY_START_DATE: {
    id: "CALENDFY_START_DATE",
    defaultMessage: "Startdatum",
  },
  CALENDFY_END_DATE: {
    id: "CALENDFY_END_DATE",
    defaultMessage: "Enddatum",
  },
  CALENDFY_DATE_RANGE_ERROR: {
    id: "CALENDFY_DATE_RANGE_ERROR",
    defaultMessage: "Das Enddatum muss nach dem Startdatum liegen.",
  },
  CALENDFY_RECURRING_PREP_HINT: {
    id: "CALENDFY_RECURRING_PREP_HINT",
    defaultMessage: "Plane deine wiederkehrende Stunde: Themen, Struktur, Materialien...",
  },
  CALENDFY_RECURRING_PREP_PLACEHOLDER: {
    id: "CALENDFY_RECURRING_PREP_PLACEHOLDER",
    defaultMessage: "Unterrichtsplanung hier eingeben...",
  },
  CALENDFY_WIZ_STEP_YEAR: {
    id: "CALENDFY_WIZ_STEP_YEAR",
    defaultMessage: "Schuljahr",
  },
  CALENDFY_WIZ_STEP_CLASSES: {
    id: "CALENDFY_WIZ_STEP_CLASSES",
    defaultMessage: "Stunden",
  },
  CALENDFY_WIZ_STEP_CONFIRM: {
    id: "CALENDFY_WIZ_STEP_CONFIRM",
    defaultMessage: "Bestätigen",
  },
  CALENDFY_WIZ_SETUP_YEAR: {
    id: "CALENDFY_WIZ_SETUP_YEAR",
    defaultMessage: "Schuljahr einrichten",
  },
  CALENDFY_WIZ_SETUP_YEAR_DESC: {
    id: "CALENDFY_WIZ_SETUP_YEAR_DESC",
    defaultMessage: "Definiere den Zeitraum deines Stundenplans. CalendFy generiert automatisch alle Ereignisse.",
  },
  CALENDFY_WIZ_YEAR_START: {
    id: "CALENDFY_WIZ_YEAR_START",
    defaultMessage: "Schuljahr Beginn",
  },
  CALENDFY_WIZ_YEAR_END: {
    id: "CALENDFY_WIZ_YEAR_END",
    defaultMessage: "Schuljahr Ende",
  },
  CALENDFY_WIZ_SKIP: {
    id: "CALENDFY_WIZ_SKIP",
    defaultMessage: "Überspringen",
  },
  CALENDFY_WIZ_NEXT: {
    id: "CALENDFY_WIZ_NEXT",
    defaultMessage: "Weiter →",
  },
  CALENDFY_WIZ_SETUP_CLASSES: {
    id: "CALENDFY_WIZ_SETUP_CLASSES",
    defaultMessage: "Wochenstunden einrichten",
  },
  CALENDFY_WIZ_SETUP_CLASSES_DESC: {
    id: "CALENDFY_WIZ_SETUP_CLASSES_DESC",
    defaultMessage: "Füge alle deine Klassen mit Wochentag und Uhrzeit hinzu.",
  },
  CALENDFY_WIZ_ADD_CLASS: {
    id: "CALENDFY_WIZ_ADD_CLASS",
    defaultMessage: "Neue Stunde hinzufügen",
  },
  CALENDFY_WIZ_COURSE: {
    id: "CALENDFY_WIZ_COURSE",
    defaultMessage: "Kurs",
  },
  CALENDFY_WIZ_SELECT_CLASS: {
    id: "CALENDFY_WIZ_SELECT_CLASS",
    defaultMessage: "Klasse wählen",
  },
  CALENDFY_WIZ_ADD_ENTRY: {
    id: "CALENDFY_WIZ_ADD_ENTRY",
    defaultMessage: "Stunde hinzufügen",
  },
  CALENDFY_WIZ_BACK: {
    id: "CALENDFY_WIZ_BACK",
    defaultMessage: "← Zurück",
  },
  CALENDFY_WIZ_REVIEW: {
    id: "CALENDFY_WIZ_REVIEW",
    defaultMessage: "Alles überprüfen",
  },
  CALENDFY_WIZ_REVIEW_DESC: {
    id: "CALENDFY_WIZ_REVIEW_DESC",
    defaultMessage: "CalendFy generiert automatisch alle Ereignisse für das Schuljahr.",
  },
  CALENDFY_WIZ_PERIOD: {
    id: "CALENDFY_WIZ_PERIOD",
    defaultMessage: "Zeitraum",
  },
  CALENDFY_WIZ_TEACHING_WEEKS: {
    id: "CALENDFY_WIZ_TEACHING_WEEKS",
    defaultMessage: "Unterrichtswochen",
  },
  CALENDFY_WIZ_WEEKS: {
    id: "CALENDFY_WIZ_WEEKS",
    defaultMessage: "Wochen",
  },
  CALENDFY_WIZ_EVENTS_AUTO: {
    id: "CALENDFY_WIZ_EVENTS_AUTO",
    defaultMessage: "Ereignisse werden automatisch generiert",
  },
  CALENDFY_WIZ_CREATING: {
    id: "CALENDFY_WIZ_CREATING",
    defaultMessage: "Erstelle...",
  },
  CALENDFY_WIZ_GENERATE: {
    id: "CALENDFY_WIZ_GENERATE",
    defaultMessage: "✓ Stundenplan erstellen",
  },
  CALENDFY_PREP_PLACEHOLDER: {
    id: "CALENDFY_PREP_PLACEHOLDER",
    defaultMessage: "z.B.\n## Thema\nBruchrechnung \u2013 Einführung\n\n## Ablauf\n- [ ] Einstieg (10 min): Wiederholung...\n- [ ] Hauptteil (25 min): Neue Inhalte...\n- [ ] Sicherung (10 min): Übung...",
  },
  CALENDFY_DELETE_CONFIRM_TITLE: {
    id: "CALENDFY_DELETE_CONFIRM_TITLE",
    defaultMessage: "Termin löschen",
  },
  CALENDFY_DELETE_CONFIRM_DESC: {
    id: "CALENDFY_DELETE_CONFIRM_DESC",
    defaultMessage: "Möchtest du diesen Termin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  },
  CALENDFY_DELETE: {
    id: "CALENDFY_DELETE",
    defaultMessage: "Löschen",
  },
  CALENDFY_TEMPLATE_REPLACE_CONFIRM: {
    id: "CALENDFY_TEMPLATE_REPLACE_CONFIRM",
    defaultMessage: "Aktuelle Vorbereitungsinhalte durch diese Vorlage ersetzen?",
  },
  CALENDFY_WIZ_PARTIAL_ERROR: {
    id: "CALENDFY_WIZ_PARTIAL_ERROR",
    defaultMessage: "Einige Regeln konnten nicht erstellt werden. {count} von {total} erstellt.",
  },
  CALENDFY_WIZ_OVERLAP_ERROR: {
    id: "CALENDFY_WIZ_OVERLAP_ERROR",
    defaultMessage: 'Zeitkonflikt mit \u201E{entry}\u201C. Ein Lehrer kann nicht zwei Klassen gleichzeitig unterrichten.',
  },
  CALENDFY_WIZ_RESULT_SUCCESS: {
    id: "CALENDFY_WIZ_RESULT_SUCCESS",
    defaultMessage: "Dein Stundenplan ist fertig!",
  },
  CALENDFY_WIZ_RESULT_PARTIAL: {
    id: "CALENDFY_WIZ_RESULT_PARTIAL",
    defaultMessage: "Stundenplan mit Konflikten erstellt",
  },
  CALENDFY_WIZ_RESULT_BLOCKED: {
    id: "CALENDFY_WIZ_RESULT_BLOCKED",
    defaultMessage: "Alle Zeitfenster sind bereits belegt",
  },
  CALENDFY_WIZ_RESULT_EVENTS: {
    id: "CALENDFY_WIZ_RESULT_EVENTS",
    defaultMessage: "Termine erstellt",
  },
  CALENDFY_WIZ_RESULT_SKIPPED: {
    id: "CALENDFY_WIZ_RESULT_SKIPPED",
    defaultMessage: "Termine \u00FCbersprungen",
  },
  CALENDFY_WIZ_RESULT_SKIP_REASON: {
    id: "CALENDFY_WIZ_RESULT_SKIP_REASON",
    defaultMessage: "Diese Zeitfenster hatten bereits Termine. Ein Lehrer kann nicht an zwei Orten gleichzeitig sein.",
  },
  CALENDFY_WIZ_RESULT_RULE: {
    id: "CALENDFY_WIZ_RESULT_RULE",
    defaultMessage: "wiederkehrende Regel erstellt",
  },
  CALENDFY_WIZ_RESULT_RULES: {
    id: "CALENDFY_WIZ_RESULT_RULES",
    defaultMessage: "wiederkehrende Regeln erstellt",
  },
  CALENDFY_WIZ_RESULT_DONE: {
    id: "CALENDFY_WIZ_RESULT_DONE",
    defaultMessage: "Stundenplan ansehen",
  },
  CALENDFY_WIZ_RESULT_CLOSE: {
    id: "CALENDFY_WIZ_RESULT_CLOSE",
    defaultMessage: "Verstanden",
  },
  CALENDFY_HW_DELETE_ERROR: {
    id: "CALENDFY_HW_DELETE_ERROR",
    defaultMessage: "Hausaufgabe konnte nicht gel\u00F6scht werden",
  },
  MODULE_CALENDFY_DESC: {
    id: "MODULE_CALENDFY_DESC",
    defaultMessage: "Unterricht und Termine planen",
  },
  CALENDFY_QUICKSTART_TITLE: {
    id: "CALENDFY_QUICKSTART_TITLE",
    defaultMessage: "Erste Schritte",
  },
  CALENDFY_QUICKSTART_DISMISS: {
    id: "CALENDFY_QUICKSTART_DISMISS",
    defaultMessage: "Verstanden, danke!",
  },
  CALENDFY_QS_STEP1_TITLE: {
    id: "CALENDFY_QS_STEP1_TITLE",
    defaultMessage: "Ersten Termin erstellen",
  },
  CALENDFY_QS_STEP1_DESC: {
    id: "CALENDFY_QS_STEP1_DESC",
    defaultMessage: 'Tippe auf \u201E+Termin\u201C, um eine Stunde, Klausur oder Veranstaltung hinzuzuf\u00FCgen.',
  },
  CALENDFY_QS_STEP2_TITLE: {
    id: "CALENDFY_QS_STEP2_TITLE",
    defaultMessage: "Automatisiere mit Regeln",
  },
  CALENDFY_QS_STEP2_DESC: {
    id: "CALENDFY_QS_STEP2_DESC",
    defaultMessage: 'Nutze \u201EWiederkehrend\u201C, um Termine w\u00F6chentlich zu wiederholen \u2014 einmal einstellen, fertig.',
  },
  CALENDFY_QS_STEP3_TITLE: {
    id: "CALENDFY_QS_STEP3_TITLE",
    defaultMessage: "Alles auf einmal planen",
  },
  CALENDFY_QS_STEP3_DESC: {
    id: "CALENDFY_QS_STEP3_DESC",
    defaultMessage: "Der Stundenplan-Assistent erstellt den kompletten Plan einer Klasse auf einen Schlag.",
  },
  CALENDFY_QS_STEP4_TITLE: {
    id: "CALENDFY_QS_STEP4_TITLE",
    defaultMessage: "Filtern & exportieren",
  },
  CALENDFY_QS_STEP4_DESC: {
    id: "CALENDFY_QS_STEP4_DESC",
    defaultMessage: "Filtere nach Klasse und exportiere als iCal für Google Kalender oder Outlook.",
  },
  CALENDFY_EXPORT_ICAL: {
    id: "CALENDFY_EXPORT_ICAL",
    defaultMessage: "iCal-Datei",
  },
  CALENDFY_EXPORT_GOOGLE: {
    id: "CALENDFY_EXPORT_GOOGLE",
    defaultMessage: "Google Kalender",
  },
  CALENDFY_EXPORT_OUTLOOK: {
    id: "CALENDFY_EXPORT_OUTLOOK",
    defaultMessage: "Outlook",
  },
  CALENDFY_EXPORT_WARN_MANY: {
    id: "CALENDFY_EXPORT_WARN_MANY",
    defaultMessage: "Nur der erste Termin wurde ge\u00F6ffnet. Nutze den iCal-Download f\u00FCr mehrere Termine.",
  },
  CALENDFY_CONFLICT_HEADER: {
    id: "CALENDFY_CONFLICT_HEADER",
    defaultMessage: "Zeitkonflikt \u2014 dieser Slot ist belegt",
  },
  CALENDFY_CONFLICT_DESC_ONE: {
    id: "CALENDFY_CONFLICT_DESC_ONE",
    defaultMessage: "Dein Termin \u00FCberschneidet sich mit einem bestehenden. Du kannst trotzdem speichern, aber pr\u00FCfe ggf. die Uhrzeit.",
  },
  CALENDFY_CONFLICT_DESC_MANY: {
    id: "CALENDFY_CONFLICT_DESC_MANY",
    defaultMessage: "Dein Termin \u00FCberschneidet sich mit {count} bestehenden Terminen. Du kannst trotzdem speichern, aber pr\u00FCfe ggf. die Uhrzeit.",
  },
  CALENDFY_CONFLICT_EVENT_FALLBACK: {
    id: "CALENDFY_CONFLICT_EVENT_FALLBACK",
    defaultMessage: "Termin",
  },
  CALENDFY_RTE_UNDO: {
    id: "CALENDFY_RTE_UNDO",
    defaultMessage: "R\u00FCckg\u00E4ngig",
  },
  CALENDFY_RTE_REDO: {
    id: "CALENDFY_RTE_REDO",
    defaultMessage: "Wiederholen",
  },
  CALENDFY_RTE_HEADING: {
    id: "CALENDFY_RTE_HEADING",
    defaultMessage: "\u00DCberschrift",
  },
  CALENDFY_RTE_BOLD: {
    id: "CALENDFY_RTE_BOLD",
    defaultMessage: "Fett",
  },
  CALENDFY_RTE_ITALIC: {
    id: "CALENDFY_RTE_ITALIC",
    defaultMessage: "Kursiv",
  },
  CALENDFY_RTE_UNDERLINE: {
    id: "CALENDFY_RTE_UNDERLINE",
    defaultMessage: "Unterstrichen",
  },
  CALENDFY_RTE_HIGHLIGHT: {
    id: "CALENDFY_RTE_HIGHLIGHT",
    defaultMessage: "Hervorheben",
  },
  CALENDFY_RTE_BULLET_LIST: {
    id: "CALENDFY_RTE_BULLET_LIST",
    defaultMessage: "Aufz\u00E4hlungsliste",
  },
  CALENDFY_RTE_NUMBERED_LIST: {
    id: "CALENDFY_RTE_NUMBERED_LIST",
    defaultMessage: "Nummerierte Liste",
  },
  CALENDFY_RTE_TASK_LIST: {
    id: "CALENDFY_RTE_TASK_LIST",
    defaultMessage: "Aufgabenliste",
  },
  CALENDFY_RTE_BLOCKQUOTE: {
    id: "CALENDFY_RTE_BLOCKQUOTE",
    defaultMessage: "Zitat",
  },
  CALENDFY_RTE_CODE_BLOCK: {
    id: "CALENDFY_RTE_CODE_BLOCK",
    defaultMessage: "Codeblock",
  },
  CALENDFY_RTE_DIVIDER: {
    id: "CALENDFY_RTE_DIVIDER",
    defaultMessage: "Trennlinie",
  },
  CALENDFY_TYPE_ABBREV_CLASS: {
    id: "CALENDFY_TYPE_ABBREV_CLASS",
    defaultMessage: "KLS",
  },
  CALENDFY_TYPE_ABBREV_EXAM: {
    id: "CALENDFY_TYPE_ABBREV_EXAM",
    defaultMessage: "PR\u00DC",
  },
  CALENDFY_TYPE_ABBREV_SPECIAL: {
    id: "CALENDFY_TYPE_ABBREV_SPECIAL",
    defaultMessage: "SPC",
  },
  CALENDFY_TYPE_ABBREV_HOLIDAY: {
    id: "CALENDFY_TYPE_ABBREV_HOLIDAY",
    defaultMessage: "FEI",
  },
  CALENDFY_TYPE_ABBREV_SUBSTITUTION: {
    id: "CALENDFY_TYPE_ABBREV_SUBSTITUTION",
    defaultMessage: "VRT",
  },
  CALENDFY_TYPE_ABBREV_OTHER: {
    id: "CALENDFY_TYPE_ABBREV_OTHER",
    defaultMessage: "AND",
  },
  CALENDFY_EMPTY_WEEK: {
    id: "CALENDFY_EMPTY_WEEK",
    defaultMessage: "Keine Termine diese Woche",
  },
  CALENDFY_EMPTY_MONTH: {
    id: "CALENDFY_EMPTY_MONTH",
    defaultMessage: "Keine Termine diesen Monat",
  },
  CALENDFY_EMPTY_HINT: {
    id: "CALENDFY_EMPTY_HINT",
    defaultMessage: "Tippe auf \u201E+Termin\u201C oder nutze den Stundenplan-Assistenten.",
  },
  CALENDFY_NAV_PREV: {
    id: "CALENDFY_NAV_PREV",
    defaultMessage: "Zur\u00FCck",
  },
  CALENDFY_NAV_NEXT: {
    id: "CALENDFY_NAV_NEXT",
    defaultMessage: "Weiter",
  },
  CALENDFY_ACTION_EDIT: {
    id: "CALENDFY_ACTION_EDIT",
    defaultMessage: "Termin bearbeiten",
  },
  CALENDFY_ACTION_DELETE: {
    id: "CALENDFY_ACTION_DELETE",
    defaultMessage: "Termin l\u00F6schen",
  },
  CALENDFY_ACTION_DUPLICATE: {
    id: "CALENDFY_ACTION_DUPLICATE",
    defaultMessage: "Termin duplizieren",
  },
  CALENDFY_LOADING: {
    id: "CALENDFY_LOADING",
    defaultMessage: "Wird geladen\u2026",
  },
  NOTIFY_TITLE: {
    id: "NOTIFY_TITLE",
    defaultMessage: "Benachrichtigungen",
  },
  NOTIFY_MARK_ALL_READ: {
    id: "NOTIFY_MARK_ALL_READ",
    defaultMessage: "Alle als gelesen markieren",
  },
  NOTIFY_EMPTY: {
    id: "NOTIFY_EMPTY",
    defaultMessage: "Noch keine Benachrichtigungen",
  },
  NOTIFY_SETTINGS_TITLE: {
    id: "NOTIFY_SETTINGS_TITLE",
    defaultMessage: "Benachrichtigungseinstellungen",
  },
  NOTIFY_EMAIL_SECTION: {
    id: "NOTIFY_EMAIL_SECTION",
    defaultMessage: "E-Mail-Benachrichtigungen",
  },
  NOTIFY_EMAIL_ENABLED: {
    id: "NOTIFY_EMAIL_ENABLED",
    defaultMessage: "E-Mail-Benachrichtigungen",
  },
  NOTIFY_DAILY_SUMMARY: {
    id: "NOTIFY_DAILY_SUMMARY",
    defaultMessage: "Tägliche Zusammenfassung",
  },
  NOTIFY_SUMMARY_TIME: {
    id: "NOTIFY_SUMMARY_TIME",
    defaultMessage: "Uhrzeit der Zusammenfassung",
  },
  NOTIFY_ALERTS_SECTION: {
    id: "NOTIFY_ALERTS_SECTION",
    defaultMessage: "Benachrichtigungseinstellungen",
  },
  NOTIFY_CLASS_REMINDER: {
    id: "NOTIFY_CLASS_REMINDER",
    defaultMessage: "Unterrichtserinnerungen",
  },
  NOTIFY_REMINDER_MINUTES: {
    id: "NOTIFY_REMINDER_MINUTES",
    defaultMessage: "Erinnerung vorher (Min.)",
  },
  NOTIFY_ATTENDANCE_MISSING: {
    id: "NOTIFY_ATTENDANCE_MISSING",
    defaultMessage: "Fehlende Anwesenheit",
  },
  NOTIFY_HOMEWORK_PENDING: {
    id: "NOTIFY_HOMEWORK_PENDING",
    defaultMessage: "Ausstehende Hausaufgaben",
  },
  NOTIFY_GRADE_PENDING: {
    id: "NOTIFY_GRADE_PENDING",
    defaultMessage: "Ausstehende Noten",
  },
  NOTIFY_SETTINGS_SAVED: {
    id: "NOTIFY_SETTINGS_SAVED",
    defaultMessage: "Einstellungen gespeichert",
  },
  NOTIFY_SETTINGS_ERROR: {
    id: "NOTIFY_SETTINGS_ERROR",
    defaultMessage: "Einstellungen konnten nicht gespeichert werden",
  },
  NOTIFY_SAVING: {
    id: "NOTIFY_SAVING",
    defaultMessage: "Speichern...",
  },
  NOTIFY_CLASS_REMINDER_BODY: {
    id: "NOTIFY_CLASS_REMINDER_BODY",
    defaultMessage: "Dein Unterricht beginnt bald",
  },
  NOTIFY_ATTENDANCE_MISSING_BODY: {
    id: "NOTIFY_ATTENDANCE_MISSING_BODY",
    defaultMessage: "Anwesenheit wurde nicht erfasst",
  },
  NOTIFY_HOMEWORK_PENDING_BODY: {
    id: "NOTIFY_HOMEWORK_PENDING_BODY",
    defaultMessage: "Hausaufgaben sind fällig",
  },
  NOTIFY_GRADE_PENDING_BODY: {
    id: "NOTIFY_GRADE_PENDING_BODY",
    defaultMessage: "Noten stehen aus",
  },
  NOTIFY_NEW_ONE: {
    id: "NOTIFY_NEW_ONE",
    defaultMessage: "Neue Benachrichtigung",
  },
  NOTIFY_NEW_MANY: {
    id: "NOTIFY_NEW_MANY",
    defaultMessage: "neue Benachrichtigungen",
  },
  NOTIFY_DELETE: {
    id: "NOTIFY_DELETE",
    defaultMessage: "Löschen",
  },
  NOTIFY_TIME_NOW: {
    id: "NOTIFY_TIME_NOW",
    defaultMessage: "jetzt",
  },
  NOTIFY_TIME_MINUTES: {
    id: "NOTIFY_TIME_MINUTES",
    defaultMessage: "Min.",
  },
  NOTIFY_TIME_HOURS: {
    id: "NOTIFY_TIME_HOURS",
    defaultMessage: "Std.",
  },
  NOTIFY_TIME_DAYS: {
    id: "NOTIFY_TIME_DAYS",
    defaultMessage: "T.",
  },
  NOTIFY_UNREAD_BADGE: {
    id: "NOTIFY_UNREAD_BADGE",
    defaultMessage: "ungelesene Benachrichtigungen",
  },
  NOTIFY_MINUTES_UNIT: {
    id: "NOTIFY_MINUTES_UNIT",
    defaultMessage: "Min.",
  },
  MODULE_NOTIFY_DESC: {
    id: "MODULE_NOTIFY_DESC",
    defaultMessage: "Behalte deine Unterrichtsaufgaben im Blick",
  },

  // ── LogiFy ──
  LOGIFY: { id: "LOGIFY", defaultMessage: "Beobachtungen" },
  LOGIFY_QUICK_BUTTON: { id: "LOGIFY_QUICK_BUTTON", defaultMessage: "Beobachtung" },
  LOGIFY_TIMELINE: { id: "LOGIFY_TIMELINE", defaultMessage: "Timeline" },
  LOGIFY_BY_STUDENT: { id: "LOGIFY_BY_STUDENT", defaultMessage: "Pro Schüler*in" },
  LOGIFY_CATEGORY_ACADEMIC: { id: "LOGIFY_CATEGORY_ACADEMIC", defaultMessage: "Akademisch" },
  LOGIFY_CATEGORY_SOCIAL: { id: "LOGIFY_CATEGORY_SOCIAL", defaultMessage: "Sozial" },
  LOGIFY_CATEGORY_BEHAVIOR: { id: "LOGIFY_CATEGORY_BEHAVIOR", defaultMessage: "Verhalten" },
  LOGIFY_CATEGORY_COMMUNICATION: { id: "LOGIFY_CATEGORY_COMMUNICATION", defaultMessage: "Kommunikation" },
  LOGIFY_CATEGORY_PROGRESS: { id: "LOGIFY_CATEGORY_PROGRESS", defaultMessage: "Fortschritt" },
  LOGIFY_SENTIMENT_POSITIVE: { id: "LOGIFY_SENTIMENT_POSITIVE", defaultMessage: "Positiv" },
  LOGIFY_SENTIMENT_NEUTRAL: { id: "LOGIFY_SENTIMENT_NEUTRAL", defaultMessage: "Neutral" },
  LOGIFY_SENTIMENT_ATTENTION: { id: "LOGIFY_SENTIMENT_ATTENTION", defaultMessage: "Achtung" },
  LOGIFY_FORM_CLASS: { id: "LOGIFY_FORM_CLASS", defaultMessage: "Klasse" },
  LOGIFY_FORM_STUDENT: { id: "LOGIFY_FORM_STUDENT", defaultMessage: "Schüler*in" },
  LOGIFY_FORM_CATEGORY: { id: "LOGIFY_FORM_CATEGORY", defaultMessage: "Kategorie" },
  LOGIFY_FORM_SENTIMENT: { id: "LOGIFY_FORM_SENTIMENT", defaultMessage: "Bewertung" },
  LOGIFY_FORM_TEXT: { id: "LOGIFY_FORM_TEXT", defaultMessage: "Beobachtung" },
  LOGIFY_FORM_DATE: { id: "LOGIFY_FORM_DATE", defaultMessage: "Datum" },
  LOGIFY_FORM_LINK_EVENT: { id: "LOGIFY_FORM_LINK_EVENT", defaultMessage: "Ereignis verknüpfen (optional)" },
  LOGIFY_FORM_NO_EVENT: { id: "LOGIFY_FORM_NO_EVENT", defaultMessage: "Kein Ereignis" },
  LOGIFY_STATS_TOTAL: { id: "LOGIFY_STATS_TOTAL", defaultMessage: "Beobachtungen" },
  LOGIFY_STATS_POSITIVE: { id: "LOGIFY_STATS_POSITIVE", defaultMessage: "Positiv" },
  LOGIFY_STATS_NEUTRAL: { id: "LOGIFY_STATS_NEUTRAL", defaultMessage: "Neutral" },
  LOGIFY_STATS_ATTENTION: { id: "LOGIFY_STATS_ATTENTION", defaultMessage: "Achtung" },
  LOGIFY_CREATED: { id: "LOGIFY_CREATED", defaultMessage: "Beobachtung gespeichert" },
  LOGIFY_UPDATED: { id: "LOGIFY_UPDATED", defaultMessage: "Beobachtung aktualisiert" },
  LOGIFY_DELETED: { id: "LOGIFY_DELETED", defaultMessage: "Beobachtung gelöscht" },
  LOGIFY_NO_OBSERVATIONS: { id: "LOGIFY_NO_OBSERVATIONS", defaultMessage: "Noch keine Beobachtungen" },
  LOGIFY_DELETE_CONFIRM: { id: "LOGIFY_DELETE_CONFIRM", defaultMessage: "Beobachtung löschen?" },
  LOGIFY_DELETE_MESSAGE: { id: "LOGIFY_DELETE_MESSAGE", defaultMessage: "Diese Aktion kann nicht rückgängig gemacht werden." },
  LOGIFY_EMPTY_HINT: { id: "LOGIFY_EMPTY_HINT", defaultMessage: "Tippe auf + um deine erste Beobachtung zu erfassen" },
  LOGIFY_SELECT_CLASS: { id: "LOGIFY_SELECT_CLASS", defaultMessage: "Wähle eine Klasse aus" },
  LOGIFY_SELECT_STUDENT: { id: "LOGIFY_SELECT_STUDENT", defaultMessage: "Schüler auswählen" },
  LOGIFY_SELECT_STUDENT_HINT: { id: "LOGIFY_SELECT_STUDENT_HINT", defaultMessage: "Wähle einen Schüler aus der Liste um seine Beobachtungen zu sehen" },
  LOGIFY_NO_STUDENTS: { id: "LOGIFY_NO_STUDENTS", defaultMessage: "Keine Schüler in dieser Klasse" },
  LOGIFY_NO_STUDENTS_HINT: { id: "LOGIFY_NO_STUDENTS_HINT", defaultMessage: "Füge Schüler in ParticiFy hinzu, um Beobachtungen zu erfassen" },
  LOGIFY_GO_PARTICIFY: { id: "LOGIFY_GO_PARTICIFY", defaultMessage: "Zu ParticiFy" },
  LOGIFY_FILTERS: { id: "LOGIFY_FILTERS", defaultMessage: "Filter" },

  // ── ReportiFy ──
  REPORTIFY: {
    id: "REPORTIFY",
    defaultMessage: "Berichte",
  },
  REPORTIFY_SUBTITLE: {
    id: "REPORTIFY_SUBTITLE",
    defaultMessage: "Berichte & Analysen",
  },
  REPORTIFY_TAB_STUDENT: {
    id: "REPORTIFY_TAB_STUDENT",
    defaultMessage: "Sch\u00FCler*in",
  },
  REPORTIFY_TAB_CLASS: {
    id: "REPORTIFY_TAB_CLASS",
    defaultMessage: "Klasse",
  },
  REPORTIFY_TAB_COMPARISON: {
    id: "REPORTIFY_TAB_COMPARISON",
    defaultMessage: "Vergleich",
  },
  REPORTIFY_TAB_SAVED: {
    id: "REPORTIFY_TAB_SAVED",
    defaultMessage: "Gespeichert",
  },
  REPORTIFY_CLASS: {
    id: "REPORTIFY_CLASS",
    defaultMessage: "Klasse",
  },
  REPORTIFY_STUDENT: {
    id: "REPORTIFY_STUDENT",
    defaultMessage: "Sch\u00FCler*in",
  },
  REPORTIFY_SELECT_STUDENT: {
    id: "REPORTIFY_SELECT_STUDENT",
    defaultMessage: "Sch\u00FCler*in w\u00E4hlen\u2026",
  },
  REPORTIFY_COMPARE_STUDENTS: {
    id: "REPORTIFY_COMPARE_STUDENTS",
    defaultMessage: "Sch\u00FCler*innen (2\u20134)",
  },
  REPORTIFY_START: {
    id: "REPORTIFY_START",
    defaultMessage: "Von",
  },
  REPORTIFY_END: {
    id: "REPORTIFY_END",
    defaultMessage: "Bis",
  },
  REPORTIFY_SAVE: {
    id: "REPORTIFY_SAVE",
    defaultMessage: "Bericht speichern",
  },
  REPORTIFY_SAVE_PDF: {
    id: "REPORTIFY_SAVE_PDF",
    defaultMessage: "Speichern & PDF generieren",
  },
  REPORTIFY_SAVE_WITH_PDF: {
    id: "REPORTIFY_SAVE_WITH_PDF",
    defaultMessage: "Speichern + PDF",
  },
  REPORTIFY_SELECT_CLASS_HINT: {
    id: "REPORTIFY_SELECT_CLASS_HINT",
    defaultMessage: "W\u00E4hle eine Klasse, um zu beginnen",
  },
  REPORTIFY_SELECT_STUDENT_HINT: {
    id: "REPORTIFY_SELECT_STUDENT_HINT",
    defaultMessage: "W\u00E4hle eine*n Sch\u00FCler*in f\u00FCr die Vorschau",
  },
  REPORTIFY_SELECT_COMPARISON_HINT: {
    id: "REPORTIFY_SELECT_COMPARISON_HINT",
    defaultMessage: "W\u00E4hle 2\u20134 Sch\u00FCler*innen zum Vergleichen",
  },
  REPORTIFY_LOADING: {
    id: "REPORTIFY_LOADING",
    defaultMessage: "Wird geladen\u2026",
  },
  // ── Snackbar messages ──
  REPORTIFY_REPORT_SAVED: {
    id: "REPORTIFY_REPORT_SAVED",
    defaultMessage: "Bericht gespeichert",
  },
  REPORTIFY_REPORT_EXISTS: {
    id: "REPORTIFY_REPORT_EXISTS",
    defaultMessage: "Dieser Bericht existiert bereits",
  },
  REPORTIFY_SAVE_ERROR: {
    id: "REPORTIFY_SAVE_ERROR",
    defaultMessage: "Fehler beim Speichern",
  },
  REPORTIFY_PDF_DOWNLOADED: {
    id: "REPORTIFY_PDF_DOWNLOADED",
    defaultMessage: "PDF heruntergeladen",
  },
  REPORTIFY_PDF_DOWNLOAD_FAILED: {
    id: "REPORTIFY_PDF_DOWNLOAD_FAILED",
    defaultMessage: "PDF-Download fehlgeschlagen",
  },
  REPORTIFY_REPORT_DELETED: {
    id: "REPORTIFY_REPORT_DELETED",
    defaultMessage: "Bericht gel\u00F6scht",
  },
  REPORTIFY_PDF_GENERATED: {
    id: "REPORTIFY_PDF_GENERATED",
    defaultMessage: "PDF generiert",
  },
  REPORTIFY_MAX_STUDENTS: {
    id: "REPORTIFY_MAX_STUDENTS",
    defaultMessage: "Maximal 4 Sch\u00FCler*innen zum Vergleichen",
  },
  // ── Buttons / tooltips ──
  REPORTIFY_DOWNLOAD_PDF: {
    id: "REPORTIFY_DOWNLOAD_PDF",
    defaultMessage: "PDF herunterladen",
  },
  REPORTIFY_BACK: {
    id: "REPORTIFY_BACK",
    defaultMessage: "Zur\u00FCck",
  },
  REPORTIFY_OPEN_PDF: {
    id: "REPORTIFY_OPEN_PDF",
    defaultMessage: "PDF \u00F6ffnen",
  },
  REPORTIFY_GENERATE_PDF: {
    id: "REPORTIFY_GENERATE_PDF",
    defaultMessage: "PDF generieren",
  },
  REPORTIFY_DELETE: {
    id: "REPORTIFY_DELETE",
    defaultMessage: "L\u00F6schen",
  },
  REPORTIFY_VIEW: {
    id: "REPORTIFY_VIEW",
    defaultMessage: "Ansehen",
  },
  // ── Report content labels ──
  REPORTIFY_NOT_FOUND: {
    id: "REPORTIFY_NOT_FOUND",
    defaultMessage: "Bericht nicht gefunden",
  },
  REPORTIFY_NO_DATA: {
    id: "REPORTIFY_NO_DATA",
    defaultMessage: "Keine Daten verf\u00FCgbar",
  },
  REPORTIFY_NO_SAVED: {
    id: "REPORTIFY_NO_SAVED",
    defaultMessage: "Keine gespeicherten Berichte",
  },
  REPORTIFY_NO_SAVED_HINT: {
    id: "REPORTIFY_NO_SAVED_HINT",
    defaultMessage: "Wähle im Schüler-Tab eine Klasse und einen Schüler, dann klicke auf Speichern für einen Snapshot",
  },
  REPORTIFY_NOT_FOUND_HINT: {
    id: "REPORTIFY_NOT_FOUND_HINT",
    defaultMessage: "Dieser Bericht wurde möglicherweise gelöscht",
  },
  REPORTIFY_NO_STUDENTS: {
    id: "REPORTIFY_NO_STUDENTS",
    defaultMessage: "Keine Schüler in dieser Klasse",
  },
  REPORTIFY_NO_STUDENTS_HINT: {
    id: "REPORTIFY_NO_STUDENTS_HINT",
    defaultMessage: "Füge Schüler über ParticiFy zu dieser Klasse hinzu",
  },
  REPORTIFY_ATTENDANCE: {
    id: "REPORTIFY_ATTENDANCE",
    defaultMessage: "Anwesenheit",
  },
  REPORTIFY_PARTICIPATION: {
    id: "REPORTIFY_PARTICIPATION",
    defaultMessage: "Mitarbeit",
  },
  REPORTIFY_HOMEWORK: {
    id: "REPORTIFY_HOMEWORK",
    defaultMessage: "Hausaufgaben",
  },
  REPORTIFY_GRADE: {
    id: "REPORTIFY_GRADE",
    defaultMessage: "Note",
  },
  REPORTIFY_RADAR: {
    id: "REPORTIFY_RADAR",
    defaultMessage: "Radar",
  },
  REPORTIFY_HEATMAP: {
    id: "REPORTIFY_HEATMAP",
    defaultMessage: "Anwesenheit Heatmap",
  },
  REPORTIFY_MONTHLY_EVOLUTION: {
    id: "REPORTIFY_MONTHLY_EVOLUTION",
    defaultMessage: "Monatliche Entwicklung",
  },
  REPORTIFY_STREAK: {
    id: "REPORTIFY_STREAK",
    defaultMessage: "Streak",
  },
  REPORTIFY_STREAK_CURRENT: {
    id: "REPORTIFY_STREAK_CURRENT",
    defaultMessage: "Aktuell",
  },
  REPORTIFY_STREAK_BEST: {
    id: "REPORTIFY_STREAK_BEST",
    defaultMessage: "Bester",
  },
  REPORTIFY_BADGES: {
    id: "REPORTIFY_BADGES",
    defaultMessage: "Abzeichen",
  },
  REPORTIFY_CLASS_COMPARISON: {
    id: "REPORTIFY_CLASS_COMPARISON",
    defaultMessage: "Vergleich mit Klasse",
  },
  REPORTIFY_OBSERVATIONS: {
    id: "REPORTIFY_OBSERVATIONS",
    defaultMessage: "Beobachtungen",
  },
  REPORTIFY_RISK_DISTRIBUTION: {
    id: "REPORTIFY_RISK_DISTRIBUTION",
    defaultMessage: "Risikoverteilung",
  },
  REPORTIFY_RISK_STABLE: {
    id: "REPORTIFY_RISK_STABLE",
    defaultMessage: "Stabil",
  },
  REPORTIFY_RISK_WARNING: {
    id: "REPORTIFY_RISK_WARNING",
    defaultMessage: "Achtung",
  },
  REPORTIFY_RISK_DANGER: {
    id: "REPORTIFY_RISK_DANGER",
    defaultMessage: "Risiko",
  },
  REPORTIFY_DISTRIBUTION: {
    id: "REPORTIFY_DISTRIBUTION",
    defaultMessage: "Verteilung",
  },
  REPORTIFY_ATT_90: {
    id: "REPORTIFY_ATT_90",
    defaultMessage: "Anw. 90%+",
  },
  REPORTIFY_PART_4: {
    id: "REPORTIFY_PART_4",
    defaultMessage: "Mitarb. 4+",
  },
  REPORTIFY_HW_80: {
    id: "REPORTIFY_HW_80",
    defaultMessage: "HW 80%+",
  },
  REPORTIFY_GRADE_10: {
    id: "REPORTIFY_GRADE_10",
    defaultMessage: "Note 10+",
  },
  REPORTIFY_STUDENTS: {
    id: "REPORTIFY_STUDENTS",
    defaultMessage: "Sch\u00FCler*innen",
  },
  REPORTIFY_COMPARISON: {
    id: "REPORTIFY_COMPARISON",
    defaultMessage: "Vergleich",
  },
  REPORTIFY_INSIGHTS: {
    id: "REPORTIFY_INSIGHTS",
    defaultMessage: "Erkenntnisse",
  },
  REPORTIFY_INSIGHT_LEADER_METRICS: {
    id: "REPORTIFY_INSIGHT_LEADER_METRICS",
    defaultMessage: "{name} f\u00FChrt in {count} von 4 Metriken in diesem Zeitraum",
  },
  REPORTIFY_INSIGHT_LOW_ATTENDANCE: {
    id: "REPORTIFY_INSIGHT_LOW_ATTENDANCE",
    defaultMessage: "{name} hat die niedrigste Anwesenheit ({value}%)",
  },
  REPORTIFY_INSIGHT_LOW_HOMEWORK: {
    id: "REPORTIFY_INSIGHT_LOW_HOMEWORK",
    defaultMessage: "{name} hat weniger als 50% der Hausaufgaben erledigt ({value}%)",
  },
  REPORTIFY_INSIGHT_LOW_GRADE: {
    id: "REPORTIFY_INSIGHT_LOW_GRADE",
    defaultMessage: "{name} hat die niedrigste Note ({value}/{max})",
  },
  REPORTIFY_INSIGHT_HIGH_PARTICIPATION: {
    id: "REPORTIFY_INSIGHT_HIGH_PARTICIPATION",
    defaultMessage: "{name} zeichnet sich durch Mitarbeit aus ({value})",
  },
  REPORTIFY_INSIGHT_TOP_GRADE: {
    id: "REPORTIFY_INSIGHT_TOP_GRADE",
    defaultMessage: "{name} hat die beste Note ({value}/{max})",
  },
  REPORTIFY_INSIGHT_HOMEWORK_GAP: {
    id: "REPORTIFY_INSIGHT_HOMEWORK_GAP",
    defaultMessage: "{gap}pp Hausaufgaben-Unterschied zwischen {highName} ({highValue}%) und {lowName} ({lowValue}%)",
  },
  REPORTIFY_INSIGHT_AT_RISK_STUDENT: {
    id: "REPORTIFY_INSIGHT_AT_RISK_STUDENT",
    defaultMessage: "{name} zeigt kombiniertes Risiko: niedrige Anwesenheit ({attendance}%) und niedrige Mitarbeit ({participation})",
  },
  REPORTIFY_YOU: {
    id: "REPORTIFY_YOU",
    defaultMessage: "Du",
  },
  REPORTIFY_CLASS_LABEL: {
    id: "REPORTIFY_CLASS_LABEL",
    defaultMessage: "Klasse",
  },
  REPORTIFY_TYPE_STUDENT: {
    id: "REPORTIFY_TYPE_STUDENT",
    defaultMessage: "Sch\u00FCler*in",
  },
  REPORTIFY_TYPE_CLASS: {
    id: "REPORTIFY_TYPE_CLASS",
    defaultMessage: "Klasse",
  },
  REPORTIFY_TYPE_COMPARISON: {
    id: "REPORTIFY_TYPE_COMPARISON",
    defaultMessage: "Vergleich",
  },
  REPORTIFY_NAME: {
    id: "REPORTIFY_NAME",
    defaultMessage: "Name",
  },
  REPORTIFY_RISK: {
    id: "REPORTIFY_RISK",
    defaultMessage: "Risiko",
  },
  REPORTIFY_DAY_MO: { id: "REPORTIFY_DAY_MO", defaultMessage: "Mo" },
  REPORTIFY_DAY_TU: { id: "REPORTIFY_DAY_TU", defaultMessage: "Di" },
  REPORTIFY_DAY_WE: { id: "REPORTIFY_DAY_WE", defaultMessage: "Mi" },
  REPORTIFY_DAY_TH: { id: "REPORTIFY_DAY_TH", defaultMessage: "Do" },
  REPORTIFY_DAY_FR: { id: "REPORTIFY_DAY_FR", defaultMessage: "Fr" },
  REPORTIFY_DAY_SA: { id: "REPORTIFY_DAY_SA", defaultMessage: "Sa" },
  REPORTIFY_DAY_SU: { id: "REPORTIFY_DAY_SU", defaultMessage: "So" },
  REPORTIFY_TITLE_REPORT: {
    id: "REPORTIFY_TITLE_REPORT",
    defaultMessage: "Bericht",
  },
  REPORTIFY_TITLE_CLASS: {
    id: "REPORTIFY_TITLE_CLASS",
    defaultMessage: "Klasse",
  },
  REPORTIFY_TITLE_COMPARISON: {
    id: "REPORTIFY_TITLE_COMPARISON",
    defaultMessage: "Vergleich",
  },
  REPORTIFY_MON_JAN: { id: "REPORTIFY_MON_JAN", defaultMessage: "Jan" },
  REPORTIFY_MON_FEB: { id: "REPORTIFY_MON_FEB", defaultMessage: "Feb" },
  REPORTIFY_MON_MAR: { id: "REPORTIFY_MON_MAR", defaultMessage: "Mär" },
  REPORTIFY_MON_APR: { id: "REPORTIFY_MON_APR", defaultMessage: "Apr" },
  REPORTIFY_MON_MAY: { id: "REPORTIFY_MON_MAY", defaultMessage: "Mai" },
  REPORTIFY_MON_JUN: { id: "REPORTIFY_MON_JUN", defaultMessage: "Jun" },
  REPORTIFY_MON_JUL: { id: "REPORTIFY_MON_JUL", defaultMessage: "Jul" },
  REPORTIFY_MON_AUG: { id: "REPORTIFY_MON_AUG", defaultMessage: "Aug" },
  REPORTIFY_MON_SEP: { id: "REPORTIFY_MON_SEP", defaultMessage: "Sep" },
  REPORTIFY_MON_OCT: { id: "REPORTIFY_MON_OCT", defaultMessage: "Okt" },
  REPORTIFY_MON_NOV: { id: "REPORTIFY_MON_NOV", defaultMessage: "Nov" },
  REPORTIFY_MON_DEC: { id: "REPORTIFY_MON_DEC", defaultMessage: "Dez" },
  REPORTIFY_PRESENT: { id: "REPORTIFY_PRESENT", defaultMessage: "anwesend" },
  REPORTIFY_ABSENT: { id: "REPORTIFY_ABSENT", defaultMessage: "abwesend" },
  REPORTIFY_LESS: { id: "REPORTIFY_LESS", defaultMessage: "Weniger" },
  REPORTIFY_MORE: { id: "REPORTIFY_MORE", defaultMessage: "Mehr" },
  REPORTIFY_BADGE_STREAK_7: { id: "REPORTIFY_BADGE_STREAK_7", defaultMessage: "7-Tage-Streak" },
  REPORTIFY_BADGE_STREAK_14: { id: "REPORTIFY_BADGE_STREAK_14", defaultMessage: "14-Tage-Streak" },
  REPORTIFY_BADGE_PERFECT_ATTENDANCE_MONTH: { id: "REPORTIFY_BADGE_PERFECT_ATTENDANCE_MONTH", defaultMessage: "Perfekte Anwesenheit (Monat)" },
  REPORTIFY_BADGE_ALL_HOMEWORK_MONTH: { id: "REPORTIFY_BADGE_ALL_HOMEWORK_MONTH", defaultMessage: "Alle HW in einem Monat" },
  REPORTIFY_BADGE_BEST_PARTICIPATION: { id: "REPORTIFY_BADGE_BEST_PARTICIPATION", defaultMessage: "Beste Mitarbeit der Klasse" },
  REPORTIFY_BADGE_IMPROVED_PARTICIPATION: { id: "REPORTIFY_BADGE_IMPROVED_PARTICIPATION", defaultMessage: "Mitarbeit verbessert" },
  REPORTIFY_ANNUAL_TREND: { id: "REPORTIFY_ANNUAL_TREND", defaultMessage: "Jahresverlauf" },
  REPORTIFY_SEPTEMBER_DIP: { id: "REPORTIFY_SEPTEMBER_DIP", defaultMessage: "Oktober ist historisch Ihr herausforderndster Monat" },
  REPORTIFY_HOMEWORK_BY_TYPE: { id: "REPORTIFY_HOMEWORK_BY_TYPE", defaultMessage: "Hausaufgaben nach Aufgabe" },
  REPORTIFY_ENGAGEMENT_DIMENSION: { id: "REPORTIFY_ENGAGEMENT_DIMENSION", defaultMessage: "Engagement" },
  REPORTIFY_PRESENCE_DIMENSION: { id: "REPORTIFY_PRESENCE_DIMENSION", defaultMessage: "Anwesenheit" },
  REPORTIFY_CORRELATION_HIGH: { id: "REPORTIFY_CORRELATION_HIGH", defaultMessage: "Hohe Korrelation Mitarbeit↔Hausaufgaben" },
  REPORTIFY_CORRELATION_HIGH_INSIGHT: { id: "REPORTIFY_CORRELATION_HIGH_INSIGHT", defaultMessage: "Schüler*innen, die mehr mitmachen, geben auch mehr Hausaufgaben ab. Um die Abgabequote zu verbessern, arbeite am Engagement im Unterricht." },
  REPORTIFY_CORRELATION_MODERATE: { id: "REPORTIFY_CORRELATION_MODERATE", defaultMessage: "Moderate Korrelation" },
  REPORTIFY_CORRELATION_MODERATE_INSIGHT: { id: "REPORTIFY_CORRELATION_MODERATE_INSIGHT", defaultMessage: "Es gibt eine gewisse Beziehung zwischen Mitarbeit und Aufgabenabgabe, aber sie ist nicht ausschlaggebend. Andere Faktoren spielen eine größere Rolle." },
  REPORTIFY_RISK_STABLE_PROFILE: { id: "REPORTIFY_RISK_STABLE_PROFILE", defaultMessage: "Stabile Leistung" },
  REPORTIFY_RISK_PRESENT_NOT_ENGAGED: { id: "REPORTIFY_RISK_PRESENT_NOT_ENGAGED", defaultMessage: "Anwesend, aber nicht engagiert" },
  REPORTIFY_RISK_ENGAGED_NOT_PRESENT: { id: "REPORTIFY_RISK_ENGAGED_NOT_PRESENT", defaultMessage: "Engagiert, aber oft abwesend" },
  REPORTIFY_RISK_AT_RISK_PROFILE: { id: "REPORTIFY_RISK_AT_RISK_PROFILE", defaultMessage: "Schüler braucht Aufmerksamkeit" },
  REPORTIFY_CONSISTENCY_TOOLTIP: { id: "REPORTIFY_CONSISTENCY_TOOLTIP", defaultMessage: "Dieser Schüler hat eine hohe Variation in der Mitarbeit — an manchen Tagen sehr aktiv, an anderen sehr passiv" },
  REPORTIFY_CONSISTENCY_CONSISTENT: { id: "REPORTIFY_CONSISTENCY_CONSISTENT", defaultMessage: "Sehr konstant" },
  REPORTIFY_CONSISTENCY_VARIABLE: { id: "REPORTIFY_CONSISTENCY_VARIABLE", defaultMessage: "Variabel" },
  REPORTIFY_CONSISTENCY_VERY_VARIABLE: { id: "REPORTIFY_CONSISTENCY_VERY_VARIABLE", defaultMessage: "Sehr variabel" },
  REPORTIFY_RATING_DISTRIBUTION: { id: "REPORTIFY_RATING_DISTRIBUTION", defaultMessage: "Bewertungsverteilung" },
  REPORTIFY_PROFILE_ENGAGED: { id: "REPORTIFY_PROFILE_ENGAGED", defaultMessage: "Engagierte Klasse" },
  REPORTIFY_PROFILE_MIXED: { id: "REPORTIFY_PROFILE_MIXED", defaultMessage: "Heterogene Klasse" },
  REPORTIFY_PROFILE_CHALLENGING: { id: "REPORTIFY_PROFILE_CHALLENGING", defaultMessage: "Herausfordernde Klasse" },
  REPORTIFY_BANNER_TITLE: { id: "REPORTIFY_BANNER_TITLE", defaultMessage: "Bericht unvollständig" },
  REPORTIFY_BANNER_NO_ATTENDANCE: { id: "REPORTIFY_BANNER_NO_ATTENDANCE", defaultMessage: "Keine Anwesenheitsdaten für diesen Zeitraum" },
  REPORTIFY_BANNER_LOW_ATTENDANCE: { id: "REPORTIFY_BANNER_LOW_ATTENDANCE", defaultMessage: "Wenige Anwesenheitsdaten (weniger als 5 Einträge)" },
  REPORTIFY_BANNER_NO_HOMEWORK: { id: "REPORTIFY_BANNER_NO_HOMEWORK", defaultMessage: "Keine Hausaufgabendaten für diesen Zeitraum" },
  REPORTIFY_BANNER_NO_GRADE: { id: "REPORTIFY_BANNER_NO_GRADE", defaultMessage: "Keine Notendaten — füge Noten in TrackiFy hinzu, um den Bericht zu vervollständigen" },
  REPORTIFY_BANNER_NO_HEATMAP: { id: "REPORTIFY_BANNER_NO_HEATMAP", defaultMessage: "Keine Anwesenheitshistorie für Heatmap" },
  REPORTIFY_BANNER_NO_STUDENTS: { id: "REPORTIFY_BANNER_NO_STUDENTS", defaultMessage: "Keine Schüler in dieser Klasse gefunden" },
  REPORTIFY_BANNER_COMPLETE_TITLE: { id: "REPORTIFY_BANNER_COMPLETE_TITLE", defaultMessage: "Dein Bericht könnte vollständiger sein" },
  REPORTIFY_BANNER_COMPLETE_SUBTITLE: { id: "REPORTIFY_BANNER_COMPLETE_SUBTITLE", defaultMessage: "Füge Daten aus anderen Modulen hinzu für bessere Einblicke" },
  REPORTIFY_BANNER_PARTICIFY: { id: "REPORTIFY_BANNER_PARTICIFY", defaultMessage: "Anwesenheit & Teilnahme" },
  REPORTIFY_BANNER_TRACKIFY: { id: "REPORTIFY_BANNER_TRACKIFY", defaultMessage: "Noten" },
  REPORTIFY_BANNER_LOGIFY: { id: "REPORTIFY_BANNER_LOGIFY", defaultMessage: "Beobachtungen" },
  REPORTIFY_BANNER_CALENDFY: { id: "REPORTIFY_BANNER_CALENDFY", defaultMessage: "Kalendertermine" },
  REPORTIFY_BANNER_ACTIVE: { id: "REPORTIFY_BANNER_ACTIVE", defaultMessage: "Aktiv" },
  REPORTIFY_BANNER_MISSING: { id: "REPORTIFY_BANNER_MISSING", defaultMessage: "Noch keine Daten" },
  REPORTIFY_BANNER_GO: { id: "REPORTIFY_BANNER_GO", defaultMessage: "Öffne" },
  REPORTIFY_RADAR_NO_GRADE: { id: "REPORTIFY_RADAR_NO_GRADE", defaultMessage: "Notenachse ist leer — keine Notendaten verfügbar" },
  PARTICIFY_HW_NAMING_NUDGE: { id: "PARTICIFY_HW_NAMING_NUDGE", defaultMessage: "Tipp: Benenne deine Hausaufgaben für bessere Einblicke in ReportiFy" },
};

export default DEUTSCH_TRANSLATIONS;
